import { useEffect, useState, useRef } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
import DelBox from '../comps/DelBox';
import Swal from "sweetalert2";
import { useNavigate } from 'react-router-dom';
import AddService from '../models/AddService';
import DischargeModal from '../models/DischargeModal';
import { RiDeleteBinLine } from 'react-icons/ri';
function IpdBilling() {
  const [busy, setBusy] = useState(false);

  const navigate = useNavigate();
  const [showDischargeModal, setShowDischargeModal] = useState(false);
  const [modalPatient, setModalPatient] = useState(null);
   const [isPaid, setIsPaid] = useState(false); 
   const [paidChanged, setPaidChanged] = useState(false);
   const [isDischarged, setIsDischarged] = useState(false);
  
      const accent = { color: "#405189" };
      const [finalPayment, setFinalPayment] = useState(0);
      const [dueChecking, setDueChecking] = useState(0);
      const [paidPayment, setPaidPayment] = useState(0);
      const [policyName, setPolicyName] = useState('');
      const [policyNo, setPolicyNo] = useState(0);

      const [duePayment, setDuePayment] = useState(0);
     const [showServices, setShowServices] = useState(false)
      const [transactionHistory, setTransactionHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [uhidErrorShown, setUhidErrorShown] = useState(false);
// lab totals already: finalPayment, paidPayment, duePayment
// add pharmacy totals:
const [pharmacyFinal, setPharmacyFinal] = useState(0);
const [pharmacyPaid, setPharmacyPaid] = useState(0);
const [pharmacyDue, setPharmacyDue] = useState(0);
// put near other useState declarations
const [activeTab, setActiveTab] = useState('lab'); // 'lab' | 'pharmacy' | 'store'
const [saving, setSaving] = useState(false);
// new states
const [payAmount, setPayAmount] = useState(''); // value entered in "Pay" field
const [computedPaid, setComputedPaid] = useState(0); // advance + transaction history sum (readonly shown in Paid)

// Add these new state variables for additional doctors
const [otAsstDoctor, setOtAsstDoctor] = useState("");
const [otAsstDocSearch, setOtAsstDocSearch] = useState("");
const [otAnesthesiaDoctor, setOtAnesthesiaDoctor] = useState("");
const [otAnesthesiaDocSearch, setOtAnesthesiaDocSearch] = useState("");
// Add these new state variables for pediatric doctor
const [otPediatricDoctor, setOtPediatricDoctor] = useState("");
const [otPediatricDocSearch, setOtPediatricDocSearch] = useState("");
// const [computedDue, setComputedDue] = useState(Number(formData.ipd_bill_due) || 0); // derived due
// Normalize server item shapes into the shape your UI expects
const normalizeItemsFromServer = (items = []) => {
  if (!Array.isArray(items)) return [];
  return items.map((it, idx) => {
    const serviceName = it.ipd_bill_item_service || it.ot_item_name || it.cat_name || it.name || it.service_name || "";
    const qty = Number(it.ipd_bill_item_qty ?? it.qty ?? 1) || 1;
    const charge = Number(it.ipd_bill_item_charge ?? it.price ?? it.cat_price) || 0;
    const dis = Number(it.ipd_bill_item_dis ?? it.discount ?? 0) || 0;
    const finalVal = Number(it.ipd_bill_item_final ?? (qty * charge - dis)) || (qty * charge - dis);

    return {
      sn: idx + 1,
      ipd_bill_item_service: serviceName,
      ipd_bill_item_qty: qty,
      ipd_bill_item_charge: charge,
      ipd_bill_item_dis: dis,
      ipd_bill_item_final: finalVal,
      ipd_bill_item_id: it.ipd_bill_item_id || it.id || it.cat_id || "",
      isBedItem: !!(it.isBedItem || it.is_bed || it.bed_flag),
      // ADD DOCTOR FIELD
      ipd_bill_item_doctor: it.ipd_bill_item_doctor || "",
    };
  });
};


// normalize incoming gender values to one of: "Male", "Female", "Other", or ""
function normalizeGender(raw) {
  if (raw === undefined || raw === null) return "";
  const s = String(raw).trim().toLowerCase();

  // common mappings (expand as needed)
  if (["male", "m", "man", "1", "true"].includes(s)) return "Male";
  if (["female", "f", "woman", "2"].includes(s)) return "Female";
  if (["other", "o", "3", "non-binary", "nonbinary"].includes(s)) return "Other";

  // map common mis-used values from your DB
  if (["active", "activated"].includes(s)) return "Male";      // <-- adjust if 'Active' actually meant something else
  if (["deactive", "inactive", "deactivated"].includes(s)) return "Female"; // <-- adjust mapping if needed

  // If it's already one of expected labels (case-insensitive)
  if (["male", "female", "other"].includes(s)) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  // fallback: return empty so UI shows none selected
  return "";
}

// format a variety of server date/datetime strings into YYYY-MM-DD
function formatDateTimeLocal(datetimeStr) {
  if (!datetimeStr) return "";

  try {
    const s = String(datetimeStr).replace('T', ' ').trim();
    const [datePart, timePart = "00:00:00"] = s.split(' ');
    const [y, m, d] = datePart.split('-').map(Number);
    const [hh = 0, mm = 0, ss = 0] = timePart.split(':').map(Number);

    if (!y || !m || !d) return "";

    // Create date in local timezone (not UTC)
    const local = new Date(y, m - 1, d, hh, mm, ss);
    const pad = n => String(n).padStart(2, '0');

    return `${local.getFullYear()}-${pad(local.getMonth() + 1)}-${pad(local.getDate())}T${pad(local.getHours())}:${pad(local.getMinutes())}`;
  } catch {
    return "";
  }
}


// was: const [computedDue, setComputedDue] = useState(Number(formData.ipd_bill_due) || 0);
const [computedDue, setComputedDue] = useState(0);

// parse backend "YYYY-MM-DD HH:mm:ss" (or "YYYY-MM-DD") into local "YYYY-MM-DDTHH:mm"
function formatForInput(datetimeStr) {
  if (!datetimeStr) return "";

  // Accept either "YYYY-MM-DD HH:mm:ss" or "YYYY-MM-DDTHH:mm:ss" or "YYYY-MM-DD"
  const cleaned = datetimeStr.replace('T', ' ').trim();
  const [datePart, timePart] = cleaned.split(' ');

  const [year, month, day] = (datePart || "").split('-').map(n => parseInt(n, 10));
  let hours = 0, minutes = 0, seconds = 0;

  if (timePart) {
    const [h, m, s] = timePart.split(':').map(n => parseInt(n, 10));
    hours = isNaN(h) ? 0 : h;
    minutes = isNaN(m) ? 0 : m;
    seconds = isNaN(s) ? 0 : s;
  }

  // Build a Date in local timezone from components (avoids ambiguous string parsing)
  const localDate = new Date(year, (month || 1) - 1, day || 1, hours, minutes, seconds);

  const pad = n => String(n).padStart(2, '0');
  const yyyy = localDate.getFullYear();
  const mm = pad(localDate.getMonth() + 1);
  const dd = pad(localDate.getDate());
  const hh = pad(localDate.getHours());
  const min = pad(localDate.getMinutes());

  return `${yyyy}-${mm}-${dd}T${hh}:${min}`; // suitable for type="datetime-local"
}



function parseServerDate(datetimeStr) {
  if (!datetimeStr) return null;
  const s = String(datetimeStr).trim();
  // Try ISO parse fallback
  // If it's like 'YYYY-MM-DD' or 'YYYY-MM-DDTHH:MM:SS', Date can parse in most browsers as UTC,
  // but prefer component parsing for safer local result.
  const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}):?(\d{2})?)?/);
  if (isoMatch) {
    const y = parseInt(isoMatch[1], 10);
    const m = parseInt(isoMatch[2], 10) - 1;
    const d = parseInt(isoMatch[3], 10);
    const hh = isoMatch[4] ? parseInt(isoMatch[4], 10) : 0;
    const mm = isoMatch[5] ? parseInt(isoMatch[5], 10) : 0;
    const ss = isoMatch[6] ? parseInt(isoMatch[6], 10) : 0;
    return new Date(y, m, d, hh, mm, ss);
  }
  const dt = new Date(s);
  if (!isNaN(dt.getTime())) return dt;
  return null;
}

function formatDateTime12h(dateInput) {
  if (!dateInput && dateInput !== 0) return '';
  let dateObj = dateInput instanceof Date ? dateInput : parseServerDate(dateInput);
  if (!dateObj) {
    try { dateObj = new Date(dateInput); } catch { dateObj = null; }
  }
  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) return '';
  const day = String(dateObj.getDate()).padStart(2, '0');
  const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const month = monthNames[dateObj.getMonth()];
  const year = dateObj.getFullYear();
  let hours = dateObj.getHours();
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours === 0 ? 12 : hours;
  const hourStr = String(hours).padStart(2, '0');
  return `${day} ${month}- ${year} ${hourStr}:${minutes} ${ampm}`;
}


const handlePrintIPDBill = async () => {
  // Show SweetAlert with checkboxes
  const { value: formValues, isConfirmed } = await Swal.fire({
    title: 'IPD Bill Print Options',
    html: `
      <div style="text-align: left; padding: 10px;">
        <div style="margin-bottom: 15px;">
          <label style="display: flex; align-items: center; cursor: pointer;">
            <input type="checkbox" id="includeHeader" checked style="margin-right: 10px; width: 18px; height: 18px;">
            <span><strong>Include Header Image</strong></span>
          </label>
          <small style="margin-left: 28px; color: #666;">Hospital logo and header</small>
        </div>
        
        <div style="margin-bottom: 15px;">
          <label style="display: flex; align-items: center; cursor: pointer;">
            <input type="checkbox" id="includeLab" ${Number(finalPayment) > 0 ? 'checked' : ''} 
              ${Number(finalPayment) === 0 ? 'disabled' : ''} 
              style="margin-right: 10px; width: 18px; height: 18px;">
            <span><strong>Include Lab Details</strong></span>
          </label>
          <small style="margin-left: 28px; color: #666;">
            ${Number(finalPayment) > 0 
              ? `Amount: ₹${Number(finalPayment).toFixed(2)}, Due: ₹${Number(duePayment).toFixed(2)}` 
              : 'No lab billing found'}
          </small>
        </div>
        
        <div style="margin-bottom: 15px;">
          <label style="display: flex; align-items: center; cursor: pointer;">
            <input type="checkbox" id="includePharmacy" ${Number(pharmacyFinal) > 0 ? 'checked' : ''} 
              ${Number(pharmacyFinal) === 0 ? 'disabled' : ''} 
              style="margin-right: 10px; width: 18px; height: 18px;">
            <span><strong>Include Pharmacy Details</strong></span>
          </label>
          <small style="margin-left: 28px; color: #666;">
            ${Number(pharmacyFinal) > 0 
              ? `Amount: ₹${Number(pharmacyFinal).toFixed(2)}, Due: ₹${Number(pharmacyDue).toFixed(2)}` 
              : 'No pharmacy billing found'}
          </small>
        </div>
      </div>
    `,
    focusConfirm: false,
    showCancelButton: true,
    confirmButtonText: 'Print',
    cancelButtonText: 'Cancel',
    width: 500,
    preConfirm: () => {
      return {
        includeHeader: document.getElementById('includeHeader').checked,
        includeLab: document.getElementById('includeLab').checked,
        includePharmacy: document.getElementById('includePharmacy').checked,
      };
    }
  });

  if (isConfirmed && formValues) {
    await generatePDF(formData, formValues);
  }
};

  
    const [ldata, setLdata] = useState(null);
    const [otDoctor, setOtDoctor] = useState("");
    const [otDate, setOtDate] = useState("");
    const [dayDifference, setDayDifference] = useState(0);
    const [image, setImage] = useState('')
           const [watermarkImage, setWatermarkImage] = useState('');
           const [footerImage, setFooterImage] = useState('');
        const [otUhidSuggestions, setOtUhidSuggestions] = useState([]);
          const [otDocSearch, setOtDocSearch] = useState("");
              const otDocRef = useRef();
              // add near other refs:
const serviceSearchRef = useRef(null);
const serviceListRef = useRef(null);
// read stored user robustly (same rule as your IpdPataintList.getStoredUser)
const getStoredUserLocal = () => {
  try {
    const s = sessionStorage.getItem("ldata") || localStorage.getItem("ldata") || localStorage.getItem("data") || sessionStorage.getItem("data");
    if (!s) return null;
    return JSON.parse(s);
  } catch (e) {
    console.warn('parse stored user failed', e);
    return null;
  }
};

// compute isAdmin (same checks you used already)
const _storedUser = getStoredUserLocal();
const isAdminLocal = Boolean(
  _storedUser &&
  (
    _storedUser.is_admin === 1 ||
    _storedUser.isAdmin === 1 ||
    _storedUser.role === 'admin' ||
    _storedUser.user_type === 'admin' ||
    String(_storedUser.role_id) === '1' ||
    String(_storedUser.roleId) === '1' ||
    _storedUser.user_role === 'admin'
  )
);

const isAdmin = String(ldata?.user_type || '').toLowerCase() === 'admin';
// ensure showServices is in state (you already have it)

          const [showOtDocOptions, setShowOtDocOptions] = useState(false);
    const [formData, setFormData] = useState({
        otitems: [
            {
                sn: 0,
                ipd_bill_item_service: '',
                ipd_bill_item_qty: '',
                ipd_bill_item_charge: '',
                ipd_bill_item_dis: '',
                ipd_bill_item_final: ''
            }
        ],
        services: [],
        l1: [],
        doc: [],
        wards: [],
        ipd_bill_id: '',
        ipd_no: '',
        ipd_parent_number: '',
        ipd_bill_uhid: '',
        ipd_bill_doa: '',
        ipd_bill_patient_name: '',
        ipd_bill_patient_phone: '',
        ipd_bill_patient_address: '',
        ipd_bill_patient_gender: '',
        ipd_bill_patient_age: '',
        ipd_bill_ward: '',
        ipd_bill_bed: '',
        ipd_bill_date: '',
        ipd_bill_concult_doctor: '',
        ipd_bill_refered_doctor: '',

        ipd_broker_id: '',
    ipd_broker_name: '',
    broker_id: '',
    broker_name: '',
    ipd_policy_name: '',
        ot_asst_doctor: '',
        ot_anesthesia_doctor: '',
        ot_pediatric_doctor: '',
        ipd_bill_total_amt: '',
        ipd_bill_discount: '',
        ipd_bill_fixed_deposit: '',
        ipd_bill_final_amt: '',
        ipd_bill_adv_amount: '',
        ipd_bill_paid: '',
        ipd_bill_due: '',
        ipd_bill_pay_mode: '',
        ipd_bill_remarks: '',
        ipd_bill_user: '',
        ipd_bill_ot: '',




        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });

  
const [isFinalized, setIsFinalized] = useState(false); // track save/pay click
const [originalPaid, setOriginalPaid] = useState(formData.ipd_bill_paid); // old p





// Creates / updates the IPD bill on server and returns the axios response.
// Re-uses the same form fields you already prepare in handleSubmit.
const saveIpdBill = async () => {
  // if already saving, return a rejected promise to avoid duplicates
  if (saving) return Promise.reject(new Error('Save already in progress'));

  setSaving(true);
  try {
    const fd = new FormData();
    fd.append('ipd_bill_id', formData.ipd_bill_id || '');
    fd.append('ipd_parent_number', formData.ipd_parent_number || '');
    fd.append('ipd_bill_uhid', (formData.ipd_bill_uhid && String(formData.ipd_bill_uhid).trim()) || (formData.ot_uhid_no && String(formData.ot_uhid_no).trim()) || '');

    fd.append('ipd_bill_doa', formData.ipd_bill_doa || '');
    fd.append('ipd_bill_patient_name', formData.ipd_bill_patient_name || '');
    fd.append('ipd_bill_patient_phone', formData.ipd_bill_patient_phone || '');
    fd.append('ipd_bill_patient_address', formData.ipd_bill_patient_address || '');
    fd.append('ipd_bill_patient_gender', formData.ipd_bill_patient_gender || '');
    fd.append('ipd_bill_patient_age', formData.ipd_bill_patient_age || '');
    fd.append('ipd_bill_ward', formData.ipd_bill_ward || '');
    fd.append('ipd_bill_bed', formData.ipd_bill_bed || '');
    fd.append('ipd_bill_date', formData.ipd_bill_date || '');
    fd.append('ipd_bill_concult_doctor', formData.ipd_bill_concult_doctor || '');
    fd.append('ipd_bill_refered_doctor', formData.ipd_bill_refered_doctor || '');
    fd.append('broker_id', formData.ipd_broker_id || formData.broker_id || '');
    fd.append('broker_name', formData.ipd_broker_name || formData.broker_name || '');
    fd.append('ipd_broker_id', formData.ipd_broker_id || formData.broker_id || '');
    fd.append('ipd_broker_name', formData.ipd_broker_name || formData.broker_name || '');
    fd.append('ipd_policy_name', formData.ipd_policy_name || '');
    fd.append('ipd_bill_total_amt', formData.ipd_bill_total_amt || 0);
    fd.append('ipd_bill_discount', formData.ipd_bill_discount || 0);
    fd.append('ipd_bill_fixed_deposit', formData.ipd_bill_fixed_deposit || 0);
    fd.append('ipd_bill_final_amt', formData.ipd_bill_final_amt || 0);
    fd.append('ipd_bill_adv_amount', formData.ipd_bill_adv_amount || 0);
    fd.append('ipd_bill_paid', formData.ipd_bill_paid || 0);
    fd.append('ipd_bill_due', formData.ipd_bill_due || 0);
    fd.append('ipd_bill_pay_mode', formData.ipd_bill_pay_mode || '');
    fd.append('ipd_bill_remarks', formData.ipd_bill_remarks || '');
    
    // ✅ PREPARE ITEMS WITH IPD NO AND UHID
    const itemsWithMetadata = (formData.otitems || []).map(item => ({
      ...item,
      ipd_no: formData.ipd_no || '',
      ipd_bill_uhid: formData.ipd_bill_uhid || formData.ot_uhid_no || ''
    }));
    
    fd.append('items', JSON.stringify(itemsWithMetadata));
    
    fd.append('ipd_bill_case', formData.ipd_bill_case || '');
    fd.append('ipd_bill_ot', formData.ipd_bill_ot || otDate || '');
    fd.append('ipd_no', formData.ipd_no || '');
    fd.append('ipd_bill_user', ldata?.user_id || (formData.ipd_bill_user || 1));

    const response = await axios.post(AppConst.BASE_URL + AppConst.addIpdBillUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    if (response?.data?.status) {
      // mark saved/finalized and update id if backend returned it
      const newBillId = response.data.dt?.ipd_bill_id || response.data.dt?.id || response.data.dt?.bill_id || formData.ipd_bill_id;
      setFormData(prev => ({
        ...prev,
        ipd_bill_id: newBillId,
        ipd_bill_paid: response.data.dt?.ipd_bill_paid ?? prev.ipd_bill_paid,
        ipd_bill_due: response.data.dt?.ipd_bill_due ?? prev.ipd_bill_due,
        isAlert: true,
        alertMsg: response.data.success || 'Saved',
        alertMsgTyp: response.data.type || 'success'
      }));
      setIsFinalized(true);
      sessionStorage.removeItem("ot_dt");
      toast.success(response.data.success || "IPD Bill saved");
      setSaving(false);
      return response;
    } else {
      setSaving(false);
      // return the response so caller can show message
      return response;
    }
  } catch (err) {
    setSaving(false);
    console.error("saveIpdBill error", err);
    throw err;
  }
};

const handleSubmit = async (e) => {
  if (e && e.preventDefault) e.preventDefault();

  const { isConfirmed } = await Swal.fire({
    title: "Save IPD Bill?",
    text: "Do you want to save/update this IPD bill now?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, save",
    cancelButtonText: "Cancel",
  });

  if (!isConfirmed) return;

  Swal.fire({ title: "Saving...", allowOutsideClick: false, didOpen: () => Swal.showLoading() });

  try {
    const response = await saveIpdBill();
    
    console.log("=== SAVE RESPONSE DEBUG ===");
    console.log("Full response.data:", response?.data);
    console.log("transaction_history:", response?.data?.transaction_history);
    console.log("Is array?", Array.isArray(response?.data?.transaction_history));
    console.log("Length:", response?.data?.transaction_history?.length);
    
    Swal.close();

    if (response?.data?.status) {
      const returnedId = response.data.dt?.ipd_bill_id || response.data.dt?.id || response.data.dt?.bill_id || formData.ipd_bill_id;
      const returnedUhid = response.data.dt?.ipd_bill_uhid || response.data.dt?.uhid || response.data.dt?.ot_uhid_no || formData.ipd_bill_uhid || formData.ot_uhid_no;

      // ✅ STEP 1: Update formData
      setFormData(prev => ({
        ...prev,
        isAlert: true,
        alertMsg: response.data.success,
        alertMsgTyp: response.data.type,
        ipd_bill_id: returnedId,
        ipd_bill_paid: response.data.dt?.ipd_bill_paid || prev.ipd_bill_paid,
        ipd_bill_due: response.data.dt?.ipd_bill_due || prev.ipd_bill_due
      }));

      sessionStorage.removeItem("ot_dt");
      setIsFinalized(true);

      // ✅ STEP 2: Handle transaction history from response
      if (response.data.transaction_history && Array.isArray(response.data.transaction_history)) {
        console.log("✅ Setting transaction history from save response:", response.data.transaction_history.length, "records");
        console.log("Transaction data:", response.data.transaction_history);
        setTransactionHistory(response.data.transaction_history);
      } else {
        console.log("⚠️ No transaction_history in response, fetching manually");
        try {
          if (returnedUhid) {
            console.log("Fetching by UHID:", returnedUhid);
            await fetchTransactionHistory(returnedUhid);
          } else if (returnedId) {
            console.log("Fetching by Bill ID:", returnedId);
            await fetchTransactionHistory(returnedId);
          }
        } catch (historyError) {
          console.error("Failed to fetch transaction history:", historyError);
        }
      }

      toast.success("IPD Bill saved successfully.");

    } else {
      const msg = response?.data?.success || response?.data?.message || "Failed to save IPD bill";
      Swal.fire({ icon: "error", title: "Failed", text: msg });
      setFormData(prev => ({ ...prev, isAlert: true, alertMsg: msg, alertMsgTyp: response?.data?.type || "danger" }));
    }
  } catch (err) {
    Swal.close();
    console.error("save ipd bill error", err);
    Swal.fire({ icon: "error", title: "Error", text: "Failed to save IPD bill. Check console." });
    setFormData(prev => ({ ...prev, isAlert: true, alertMsg: "Failed", alertMsgTyp: "danger" }));
  }
};



// When user clicks a tab, ensure IPD bill saved (or cancel tab change)
const handleTabClick = async (tabName) => {
  // If bill already finalized/saved, just switch
  if (isFinalized || (formData.ipd_bill_id && String(formData.ipd_bill_id).length > 0)) {
    setActiveTab(tabName);
    return;
  }

  // If not saved, ask the user what to do
  const result = await Swal.fire({
    title: "IPD bill not saved",
    html: "This billing record is not yet saved. Do you want to save it before switching tabs?",
    icon: "warning",
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: "Save & Continue",
    denyButtonText: "Continue without Saving",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    // Save then switch on success
    Swal.fire({ title: "Saving...", allowOutsideClick: false, didOpen: () => Swal.showLoading() });
    try {
      const response = await saveIpdBill();
      Swal.close();

      if (response?.data?.status) {
        setIsFinalized(true);
        setFormData(prev => ({
          ...prev,
          ipd_bill_id: response.data.dt?.ipd_bill_id || prev.ipd_bill_id,
          isAlert: true,
          alertMsg: response.data.success,
          alertMsgTyp: response.data.type,
        }));
        toast.success("Saved. Switching tab.");
        setActiveTab(tabName);
      } else {
        Swal.fire({ icon: "error", title: "Save failed", text: response?.data?.success || response?.data?.message || "Server failed to save." });
        // do not switch tab
      }
    } catch (err) {
      Swal.close();
      console.error("Error saving before tab switch:", err);
      Swal.fire({ icon: "error", title: "Error", text: "Failed to save. Tab not changed." });
    }
    return;
  }

  if (result.isDenied) {
    // user chose to continue without saving — switch tab
    setActiveTab(tabName);
    return;
  }

  // else Cancel — do nothing
};




// action can be sync or async function
const ensureSavedThen = async (action) => {
  // if already saved -> run action immediately
  if (isFinalized || (formData.ipd_bill_id && String(formData.ipd_bill_id).trim().length > 0)) {
    try { await action(); } catch (e) { console.error(e); }
    return;
  }

  // otherwise ask user to save now (only prompt when not saved)
  const res = await Swal.fire({
    title: "IPD Bill not saved",
    text: "This billing record is not saved yet. Do you want to save it now before proceeding?",
    icon: "warning",
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: "Save & Continue",
    denyButtonText: "Continue without Saving",
    cancelButtonText: "Cancel",
  });

  if (res.isConfirmed) {
    // Save first
    try {
      Swal.fire({ title: "Saving...", allowOutsideClick: false, didOpen: () => Swal.showLoading() });
      const saveResp = await saveIpdBill();
      Swal.close();
      if (saveResp?.data?.status) {
        // saved -> run action
        try { await action(); } catch (e) { console.error(e); }
      } else {
        // server returned failure -> show message and do not run action
        const msg = saveResp?.data?.success || saveResp?.data?.message || "Failed to save";
        await Swal.fire({ icon: "error", title: "Save failed", text: msg });
      }
    } catch (err) {
      Swal.close();
      console.error("Error saving before action:", err);
      await Swal.fire({ icon: "error", title: "Error", text: "Save failed. Action cancelled." });
    }
    return;
  }

  if (res.isDenied) {
    // user chooses to continue without saving
    try { await action(); } catch (e) { console.error(e); }
    return;
  }

  // cancel -> do nothing
};









function getDoctorNameById(id) {
  if (!id) return "";
  const doctor = formData.doc.find(d => String(d.user_id) === String(id));
  return doctor ? doctor.fname : "";
}


function getUserNameById(id, trx) {
  // if API already gives name, use it
  if (trx && trx.received_by_name && trx.received_by_name.trim() !== "") {
    return trx.received_by_name;
  }

  if (!id) return "";
  const user = formData.doc && formData.doc.find(d => String(d.user_id) === String(id));
  if (user && user.fname) return user.fname;
  return `User #${id}`;
}




    const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      const fd = new FormData();
      fd.append('cat_type',  "service");
      fd.append('page_no', formData.page_no + "");
      fd.append('search_key', formData.search_key + "");
      fd.append('par_by', 1 + "");
      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        
        if (response.data.status) {
 //console.log("SEVICES items  : " + JSON.stringify(response.data))
          var records = response.data.records;
          if (records != null && records != undefined) {
            setFormData(prev => ({
              ...prev,
              services: records
            }));
          }
        }
      } catch (error) {

      }
       
    }
  };

    const initData5 = async () => {
              const storedData = sessionStorage.getItem("ldata");
              if (storedData) {
                  const parsed = JSON.parse(storedData);
                  const fd = new FormData();
                  fd.append('par_by', 1 + "");
                  try {
                      const response = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl1, fd, {
                          headers: {
                              'Content-Type': 'multipart/form-data',
                          },
                      });
                    //   console.log("Bed List Response:", JSON.stringify(response));
                      if (response.data.status) {
      
                          var records = response.data.records;
                          if (records != null && records != undefined) {
                              setFormData(prev => ({
                                  ...prev,
                                  wards: records
                              }));
                          }
                      }
                  } catch (error) {
      
                  }
              }
          }

          const initData2 = async () => {
            const storedData = sessionStorage.getItem("ldata");
            if (!storedData) return;
          
            const fd = new FormData();
            fd.append('type', "doctor");
            fd.append('search_key', formData.search_key + "");
            fd.append('page_no', formData.page_no + "");
            fd.append('user_cre_by', 1 + "");
          
            try {
              const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
              });
          
              // Safely pull records array
              const recordsRaw = Array.isArray(response.data.records) ? response.data.records : [];
          
              // Normalize user_id to string for reliable comparisons later
              const records = recordsRaw.map(r => ({ ...r, user_id: String(r.user_id) }));
          
              // Save to state (or empty array if none)
              setFormData(prev => ({ ...prev, doc: records }));
          
              // Optional debug logs (remove in production)
              //console.log("Fetched doctors:", records.slice(0, 8)); // show first 8 for sanity
            } catch (error) {
              console.error("Failed to load doctors:", error);
              // keep doc as [] on error to avoid stale values
              setFormData(prev => ({ ...prev, doc: [] }));
            }
          };
          

    useEffect(() => {
      const now = new Date();
      // Format as YYYY-MM-DDTHH:mm for datetime-local input
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const formatted = `${year}-${month}-${day}T${hours}:${minutes}`;
        setFormData(prev => ({
            ...prev,
            ipd_bill_date: formatted
        }));
        //console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
            initData2();
            initData5();
        }

        if (
            sessionStorage.getItem("ot_dt") != null &&
            sessionStorage.getItem("ot_dt") != undefined &&
            sessionStorage.getItem("ot_dt").length > 0
        ) {
            var tmp = JSON.parse(sessionStorage.getItem("ot_dt") + "");
            if (tmp != null && tmp != undefined) {
                var otIts = [];
                if (tmp.items != null && tmp.items != undefined && tmp.items.length > 0) {
                    otIts = tmp.items;
                }
                setFormData(prev => ({
                    ...prev,
                    otitems: normalizeItemsFromServer(tmp.items || []),
                    ipd_bill_id: tmp.ipd_bill_id,
                    ipd_no: tmp.ipd_no,
                    ipd_parent_number: tmp.ipd_parent_number,
                    ipd_bill_uhid: tmp.ipd_bill_uhid,
                    ipd_bill_doa: tmp.ipd_bill_doa,
                    ipd_bill_patient_name: tmp.ipd_bill_patient_name,
                    ipd_bill_patient_phone: tmp.ipd_bill_patient_phone,
                    ipd_bill_patient_address: tmp.ipd_bill_patient_address,
                    ipd_bill_patient_gender: tmp.ipd_bill_patient_gender,
                    ipd_bill_patient_age: tmp.ipd_bill_patient_age,
                    ipd_bill_ward: tmp.ipd_bill_ward,
                    ipd_bill_bed: tmp.ipd_bill_bed,
                    ipd_bill_date: tmp.ipd_bill_date,
                    ipd_bill_concult_doctor: tmp.ipd_bill_concult_doctor,
                    ipd_bill_refered_doctor: tmp.ipd_bill_refered_doctor,
                    ipd_bill_total_amt: tmp.ipd_bill_total_amt,
                    ipd_bill_discount: tmp.ipd_bill_discount,
                    ipd_bill_fixed_deposit: tmp.ipd_bill_fixed_deposit,
                    ipd_bill_final_amt: tmp.ipd_bill_final_amt,
                    ipd_bill_adv_amount: tmp.ipd_bill_adv_amount,
                    ipd_bill_paid: tmp.ipd_bill_paid,
                    ipd_bill_due: tmp.ipd_bill_due,
                    ipd_bill_pay_mode: tmp.ipd_bill_pay_mode,
                    ipd_bill_remarks: tmp.ipd_bill_remarks,
                    ipd_bill_case:tmp.ipd_bill_case,
                    ipd_bill_ot:tmp.ipd_bill_ot,
                    ipd_bill_user: tmp.ipd_bill_user

                }));
            }
        }



        return () => {
            //console.log('Component unmounted');
        };
    }, []);

    function getWardNameById(wardId) {
  const ward = formData.wards.find(w => w.cat_id == wardId);
  return ward ? ward.cat_name : null;
}

// 2️⃣ Bed ka function
function getBedNameById(bedId) {

  for (let ward of formData.wards) {

    const bed = ward.beds.find(b => {
      return b.bed_id == bedId;
    });

    if (bed) {
      return bed.bed_name;
    }
  }
  return null;
}

function getBedPriceById (bedId) {

  for (let ward of formData.wards) {

    const bed = ward.beds.find(b => {
      return b.bed_id == bedId;
    });

    if (bed) {
      return bed.bed_price;
    }
  }

  return null;
}



 
const searchOtUserNow = async () => {
    const uhid = formData?.ot_uhid_no?.trim() || ""; // agar undefined/null ho to empty string

    if (uhid.length < 6) {
        setOtUhidSuggestions([]);
        setUhidErrorShown(false);
        return;
    }

    try {
        const fd = new FormData();
       fd.append("lab_reg_uhid", uhid);
fd.append("search_type", "ipdbilling");

        const response = await axios.post(
            AppConst.BASE_URL + AppConst.searchUhidUrlCall,
            fd
        );

        if (response.data.status && response.data.records?.length > 0) {
            setOtUhidSuggestions(response.data.records);
            setUhidErrorShown(false);
        } else {
            setOtUhidSuggestions([]);
            if (!uhidErrorShown) {
                toast.error("UHID Does not exist in IPD!");
                setUhidErrorShown(true);
            }
        }
    } catch (error) {
        //console.error("OT UHID Search Error:", error);
        setOtUhidSuggestions([]);
        if (!uhidErrorShown) {
            toast.error("ERROR !");
            setUhidErrorShown(true);
        }
    }
};

// Fetch all services and return those marked as default



/**
 * Required in your component scope:
 * - axios, AppConst, toast
 * - setFormData(prev => ...), setOtDoctor, setOtDocSearch, setOtAsstDoctor, setOtAsstDocSearch,
 *   setOtAnesthesiaDoctor, setOtAnesthesiaDocSearch
 * - getDoctorNameById(id), getBedNameById(bedId), getBedPriceById(bedId)
 * - formatDateTimeLocal(datetimeStr), normalizeGender(str) (optional but recommended)
 * - calculateNewTotals(state) (optional; used to recalc total/final/due)
 * - otDoctor, otAsstDoctor, otAnesthesiaDoctor (optional local states used as fallback)
 * - setFinalPayment, setPaidPayment, setDuePayment (optional for due API handling)
 */



const fetchDefaultServices = async () => {
  try {
    const fd = new FormData();
    fd.append('cat_type', 'service');
    fd.append('par_by', '1'); // keep as your normal owner id

    // Try a few page_no fallbacks because backends differ
    const pageCandidates = ['none', '0', '', '1'];
    let resp = null;
    for (const p of pageCandidates) {
      fd.set('page_no', p);
      try {
        resp = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      } catch (err) {
        console.warn('fetchDefaultServices: network error for page_no=' + p, err);
        resp = null;
      }
      if (resp && resp.data && resp.data.status && Array.isArray(resp.data.records) && resp.data.records.length > 0) {
        console.log('fetchDefaultServices: got records using page_no=' + p);
        break;
      }
    }

    if (!resp || !resp.data || !resp.data.status) {
      console.warn('fetchDefaultServices: no records or false status', resp && resp.data);
      return [];
    }

    const recs = Array.isArray(resp.data.records) ? resp.data.records : [];

    const defaults = recs.filter(r => {
      if (!r) return false;
      if (r.is_default === 1 || r.is_default === '1') return true;
      if (r.cat_default === 1 || r.cat_default === '1') return true;
      if (r.default === 1 || r.default === '1') return true;
      if (typeof r.cat_type3 === 'string' && r.cat_type3.toLowerCase().includes('default')) return true;
      return false;
    });

    console.log('fetchDefaultServices: defaults count =', defaults.length);
    return defaults;
  } catch (err) {
    console.error('fetchDefaultServices unexpected error', err);
    return [];
  }
};


// ============================================
// FIX FOR IPD BILLING - LOADING SAVED SERVICES
// ============================================

// 1. First, make sure you have this URL in your AppConst.js file:
// getIpdBillItemsUrl: '/get_ipd_bill_items',

// 2. Replace your fetchExistingBillItems function with this improved version:

const fetchExistingBillItems = async (ipdNo, uhid, billId) => {
  if (!ipdNo && !uhid && !billId) return [];
  try {
    const fd = new FormData();
    if (uhid) fd.append('ipd_uhid', uhid);
    if (ipdNo) fd.append('ipd_no', ipdNo);
    if (billId) fd.append('ipd_bill_id', billId);

    const resp = await axios.post(AppConst.BASE_URL + AppConst.getIpdBillItemsUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    if (resp?.data?.status && Array.isArray(resp.data.records)) {
      return normalizeItemsFromServer(resp.data.records); // keep your normalizer
    }
  } catch (err) {
    console.warn('fetchExistingBillItems error', err);
  }
  return [];
};



// 3. Replace your handleSelectOtUser function with this corrected version:

const handleSelectOtUser = async (user) => {
  if (!user || (!user.ipd_bill_uhid && !user.lab_reg_uhid && !user.ot_uhid_no)) return;

  if (user.ipd_user === "0" || user.ipd_user === 0) {
    toast.error("This User Already Discharged from IPD");
    return;
  }
  const policyNameFromUser = user.ipd_policy_name || user.policy_name || "";
  // Helper functions
  const findDateInObject = (obj) => {
    if (!obj || typeof obj !== "object") return null;
    const dateRegexes = [/^\d{4}-\d{2}-\d{2}/, /^\d{2}-\d{2}-\d{4}/, /^\d{4}\/\d{2}\/\d{2}/, /^\d{2}\/\d{2}\/\d{4}/];
    for (const k of Object.keys(obj)) {
      const v = obj[k];
      if (!v || typeof v !== "string") continue;
      for (const re of dateRegexes) if (re.test(v.trim())) return v.trim();
    }
    return null;
  };

  const computeBedDays = (admissionDateStr, now = new Date(), thresholdHours = 1) => {
    if (!admissionDateStr) return 1;
    const admission = new Date(admissionDateStr);
    if (isNaN(admission.getTime())) return 1;
    if (now.getTime() <= admission.getTime()) return 1;
    const dayStart = d => { const x = new Date(d); x.setHours(0,0,0,0); return x; };
    const dayEnd = d => { const x = dayStart(d); x.setDate(x.getDate()+1); return x; };
    let count = 1;
    let cursor = dayStart(admission);
    cursor.setDate(cursor.getDate() + 1);
    while (cursor.getTime() <= now.getTime()) {
      const overlapStart = Math.max(admission.getTime(), cursor.getTime());
      const overlapEnd = Math.min(now.getTime(), dayEnd(cursor).getTime());
      const overlapMs = Math.max(0, overlapEnd - overlapStart);
      const overlapHours = overlapMs / (1000 * 60 * 60);
      if (overlapHours >= thresholdHours) count += 1;
      cursor.setDate(cursor.getDate() + 1);
    }
    return count;
  };

  try {
    const admissionDateStr = user.ipd_datetime || user.ipd_bill_doa || user.ipd_reg_date || user.lab_reg_date || "";
    const doaForInput = typeof formatDateTimeLocal === 'function' ? formatDateTimeLocal(admissionDateStr) : (admissionDateStr || "");
    let dayDifference = computeBedDays(admissionDateStr, new Date(), 1);
    if (!dayDifference || dayDifference < 1) dayDifference = 1;

    const uhid = user.ipd_bill_uhid || user.lab_reg_uhid || user.ot_uhid_no || "";
    const billId = user.ipd_bill_id || "";
    const ipdNo = user.ipd_id || user.ipd_no || "";
    
    const isExistingBill = !!billId && String(billId).trim() !== "" && String(billId) !== "0";

    // ✅ CRITICAL FIX: Fetch complete IPD bill data including ALL doctors
    let advanceAmount = 0;
    let otDoctorId = "";
    let asstDoctorId = "";
    let anesthesiaDoctorId = "";
    let pediatricDoctorId = "";
    let brokerIdFromApi = "";
  let brokerNameFromApi = "";

    if (uhid) {
      try {
        const fd = new FormData();
        fd.append('ipd_uhid', uhid);
        const advResp = await axios.post(AppConst.BASE_URL + AppConst.getIpdBillByIdUrl, fd);
        
        if (advResp?.data?.status) {
          // Get advance
          advanceAmount = Number(
            advResp.data.ipd_advance_from_ipd || 
            advResp.data.dt?.ipd_bill_adv_amount ||
            advResp.data.ipd_dt?.ipd_advance || 
            advResp.data.ipd_dt?.advance || 
            user.ipd_advance ||
            user.advance ||
            0
          );
          
          // ✅ GET ALL DOCTOR IDs FROM RESPONSE
          const billData = advResp.data.dt || advResp.data.ipd_dt || {};
          brokerIdFromApi = billData.ipd_broker_id || 
          billData.broker_id || 
          billData.ipd_bill_broker_id || "";
          
brokerNameFromApi = billData.ipd_broker_name || 
            billData.broker_name || 
            billData.ipd_bill_broker_name || "";
          otDoctorId = billData.ipd_bill_concult_doctor || 
                       billData.ipd_concult_doctor || 
                       billData.ot_doctor || 
                       user.ot_doctor || 
                       user.ipd_concult_doctor || "";
                       
          asstDoctorId = billData.ot_asst_doctor || 
                         billData.ipd_asst_doctor || 
                         billData.ipd_bill_ot_asst_doctor || 
                         user.ot_asst_doctor || 
                         user.ipd_asst_doctor || "";
                         
          anesthesiaDoctorId = billData.ot_anesthesia_doctor || 
                               billData.ipd_anesthesia_doctor || 
                               billData.ipd_bill_ot_anesthesia_doctor || 
                               user.ot_anesthesia_doctor || 
                               user.ipd_anesthesia_doctor || "";
                               
          pediatricDoctorId = billData.ot_pediatric_doctor || 
                              billData.ot_Pediatric_doctor || 
                              billData.ipd_pediatric_doctor || 
                              billData.ipd_bill_ot_pediatric_doctor ||
                              user.ot_pediatric_doctor || 
                              user.ot_Pediatric_doctor || "";


          
          console.log("✅ Fetched ALL doctors from IPD Bill API:", {
            advance: advanceAmount,
            ot_doctor: otDoctorId,
            asst_doctor: asstDoctorId,
            anesthesia_doctor: anesthesiaDoctorId,
            pediatric_doctor: pediatricDoctorId
          });
        }
      } catch (err) {
        console.warn("Could not fetch from IPD Bill API:", err);
        // Fallback to user data
        advanceAmount = Number(user.ipd_advance || user.advance || 0);
        otDoctorId = user.ot_doctor || user.ipd_concult_doctor || "";
        asstDoctorId = user.ot_asst_doctor || user.ipd_asst_doctor || "";
        anesthesiaDoctorId = user.ot_anesthesia_doctor || user.ipd_anesthesia_doctor || "";
        pediatricDoctorId = user.ot_pediatric_doctor || user.ot_Pediatric_doctor || "";
      }
    }

    // Convert to strings for reliable comparison
    const referDoctorIdStr = user.ipd_refer_doctor || user.lab_reg_doc || "";
    const otDoctorIdStr = otDoctorId ? String(otDoctorId) : "";
    const asstDoctorIdStr = asstDoctorId ? String(asstDoctorId) : "";
    const anesthesiaDoctorIdStr = anesthesiaDoctorId ? String(anesthesiaDoctorId) : "";
    const pediatricDoctorIdStr = pediatricDoctorId ? String(pediatricDoctorId) : "";

    // ✅ Set ALL doctor UI states
    if (typeof setOtDoctor === 'function') setOtDoctor(otDoctorIdStr);
    if (typeof setOtDocSearch === 'function') setOtDocSearch(typeof getDoctorNameById === 'function' ? getDoctorNameById(otDoctorIdStr) || "" : "");
    
    if (typeof setOtAsstDoctor === 'function') setOtAsstDoctor(asstDoctorIdStr);
    if (typeof setOtAsstDocSearch === 'function') setOtAsstDocSearch(typeof getDoctorNameById === 'function' ? getDoctorNameById(asstDoctorIdStr) || "" : "");
    
    if (typeof setOtAnesthesiaDoctor === 'function') setOtAnesthesiaDoctor(anesthesiaDoctorIdStr);
    if (typeof setOtAnesthesiaDocSearch === 'function') setOtAnesthesiaDocSearch(typeof getDoctorNameById === 'function' ? getDoctorNameById(anesthesiaDoctorIdStr) || "" : "");
    
    if (typeof setOtPediatricDoctor === 'function') setOtPediatricDoctor(pediatricDoctorIdStr);
    if (typeof setOtPediatricDocSearch === 'function') setOtPediatricDocSearch(typeof getDoctorNameById === 'function' ? getDoctorNameById(pediatricDoctorIdStr) || "" : "");

    console.log("✅ Set all doctor states:", {
      ot: otDoctorIdStr,
      asst: asstDoctorIdStr,
      anesthesia: anesthesiaDoctorIdStr,
      pediatric: pediatricDoctorIdStr
    });

    // ... rest of your existing code for items, dates, etc.
    
    // Normalize OT date
    const rawOt = user.ot_reg_date || user.ipd_bill_ot || user.ot_date || findDateInObject(user) || "";
    let normalizedOt = "";
    if (rawOt) {
      const d = new Date(rawOt);
      if (!isNaN(d.getTime())) normalizedOt = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
      else normalizedOt = (rawOt.split && rawOt.split("T")[0]) || rawOt;
    }

    // Fetch existing items
    let existingItems = [];
    
    try {
      const fd = new FormData();
      if (uhid) fd.append('ipd_uhid', uhid);
      if (ipdNo) fd.append('ipd_no', ipdNo);
      if (billId) fd.append('ipd_bill_id', billId);
      
      const itemsResp = await axios.post(
        AppConst.BASE_URL + AppConst.getIpdBillItemsUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      
      if (itemsResp?.data?.status && Array.isArray(itemsResp.data.records) && itemsResp.data.records.length > 0) {
        existingItems = normalizeItemsFromServer(itemsResp.data.records);
        existingItems = existingItems.map(item => ({
          ...item,
          ipd_no: ipdNo || item.ipd_no || '',
          ipd_bill_uhid: uhid || item.ipd_bill_uhid || ''
        }));
      }
    } catch (err) {
      console.error('Error fetching existing bill items:', err);
    }

    // Build final items
    let finalOtItems = [];

    if (existingItems.length > 0) {
      finalOtItems = existingItems;
    } else {
      // Add bed item if needed for new bills
      let bedChargeItem = null;
      const bedId = user.ipd_bill_bed || user.lab_bed || "";
      
      if (bedId && typeof getBedPriceById === 'function' && getBedPriceById(bedId)) {
        const bedName = typeof getBedNameById === 'function' ? getBedNameById(bedId) : (user.bed_name || "");
        const bedPrice = typeof getBedPriceById === 'function' ? getBedPriceById(bedId) : (Number(user.bed_price || 0) || 0);
        const finalPrice = dayDifference * bedPrice;
        
        if (bedName && bedPrice > 0) {
          bedChargeItem = {
            ipd_bill_item_service: bedName,
            ipd_bill_item_qty: dayDifference,
            ipd_bill_item_charge: bedPrice,
            ipd_bill_item_dis: 0,
            ipd_bill_item_final: finalPrice,
            isBedItem: true,
            bed_ref_id: bedId,
            ipd_bill_item_doctor: "",
            ipd_no: ipdNo || '',
            ipd_bill_uhid: uhid || ''
          };
        }
      }
      
      if (bedChargeItem) {
        finalOtItems = [bedChargeItem];
      }
    }

    // Calculate totals
    const totalAmount = finalOtItems.reduce((s, it) => s + Number(it.ipd_bill_item_final || 0), 0);
    const discount = Number(user.ipd_bill_discount || 0);
    const fixedDeposit = Number(user.ipd_bill_fixed_deposit || 0);
    const finalAmount = totalAmount - (totalAmount * discount / 100) - fixedDeposit;
    const paidAmount = Number(user.ipd_bill_paid || 0);
    const dueAmount = finalAmount - advanceAmount - paidAmount;

    // ✅ Update formData with ALL doctor fields
    if (typeof setFormData === 'function') {
      setFormData(prev => {
        const next = {
          ...prev,
          ipd_bill_id: billId,
          ipd_no: ipdNo,
          ipd_bill_uhid: uhid,
          ipd_bill_patient_name: user.ipd_bill_patient_name || user.lab_reg_name || "",
          ipd_bill_patient_gender: typeof normalizeGender === 'function' ? normalizeGender(user.ipd_bill_patient_gender || user.lab_reg_gender) : (user.ipd_bill_patient_gender || user.lab_reg_gender || ""),
          ipd_bill_refered_doctor: String(referDoctorIdStr),
          ipd_bill_concult_doctor: otDoctorIdStr,
          ot_asst_doctor: asstDoctorIdStr,
          ot_anesthesia_doctor: anesthesiaDoctorIdStr,
          ot_pediatric_doctor: pediatricDoctorIdStr,
          ipd_bill_patient_phone: user.ipd_bill_patient_phone || user.lab_reg_mobile || "",
          ipd_bill_patient_address: user.ipd_bill_patient_address || user.lab_reg_address || "",
          ipd_bill_bed: user.ipd_bill_bed || user.lab_bed || "",
          ipd_bill_ward: user.ipd_bill_ward || user.ipd_ward,
          ipd_bill_patient_age: user.ipd_bill_patient_age || user.lab_age || "",
          ipd_bill_doa: doaForInput,
          ipd_bill_doa_raw: admissionDateStr,
          patient_type: user.lab_reg_type || "IPD",
          ipd_bill_total_amt: totalAmount.toFixed(2),
          ipd_bill_discount: discount,
          ipd_bill_fixed_deposit: fixedDeposit,
          ipd_bill_final_amt: finalAmount.toFixed(2),
          ipd_bill_adv_amount: advanceAmount,
          ipd_bill_paid: paidAmount,
          ipd_bill_due: dueAmount.toFixed(2),
          ipd_bill_pay_mode: user.ipd_bill_pay_mode || "",
          ipd_bill_remarks: user.ipd_bill_remarks || "",
          ipd_bill_user: user.ipd_bill_user || "",
          otitems: finalOtItems,
          ipd_bill_case: user.ipd_case || user.case_title || user.case_no || user.ipd_case_title || "",
          ipd_bill_ot: normalizedOt,
          ipd_broker_id: brokerIdFromApi || user.ipd_broker_id || user.broker_id || "",
          ipd_broker_name: brokerNameFromApi || user.ipd_broker_name || user.broker_name || "",
          broker_id: brokerIdFromApi || user.ipd_broker_id || user.broker_id || "",
          broker_name: brokerNameFromApi || user.ipd_broker_name || user.broker_name || "",
          ipd_policy_name: policyNameFromUser,
        };
        setPolicyName(policyNameFromUser);
        console.log("✅ FormData updated with doctors:", {
          ot: next.ipd_bill_concult_doctor,
          asst: next.ot_asst_doctor,
          anesthesia: next.ot_anesthesia_doctor,
          pediatric: next.ot_pediatric_doctor
        });

        return next;
      });
    }

    // Only add default services if NO items exist
    if (finalOtItems.length === 0) {
      if (typeof fetchDefaultServices === 'function' && typeof mergeDefaultServicesIntoBill === 'function') {
        try {
          const defaults = await fetchDefaultServices();
          if (defaults && defaults.length > 0) {
            mergeDefaultServicesIntoBill(defaults);
            toast.success(`Added ${defaults.length} default service(s)`);
          }
        } catch (e) {
          console.error("Could not auto-add default services:", e);
        }
      }
    } else {
      if (isExistingBill) {
        setIsFinalized(true);
      }
    }

    // Fetch external dues
    try {
      if (axios && AppConst && uhid) {
        const fd2 = new FormData();
        fd2.append("uhid", uhid);
        const dueRes = await axios.post(AppConst.BASE_URL + AppConst.checkUhidDueCall, fd2);
        if (dueRes?.data?.status && typeof setFinalPayment === 'function') {
          const labDetails = dueRes.data.dues?.lab || { final: 0, paid: 0, due: 0 };
          if (typeof setFinalPayment === 'function') setFinalPayment(labDetails.final);
          if (typeof setPaidPayment === 'function') setPaidPayment(labDetails.paid);
          if (typeof setDuePayment === 'function') setDuePayment(labDetails.due);
        }
      }
    } catch (err2) {
      console.warn("Check Due API Error:", err2);
    }

    // Fetch transaction history
    if (billId || uhid) {
      try {
        await fetchTransactionHistory(billId || uhid);
      } catch (err3) {
        console.warn("Could not fetch transaction history:", err3);
      }
    }

    toast.success(`${user.lab_reg_type || "IPD"} Patient data fetched successfully!`);
  } catch (err) {
    console.error("Error setting patient details:", err);
    toast.error("Failed to fetch patient details.");
  } finally {
    if (typeof setOtUhidSuggestions === 'function') setOtUhidSuggestions([]);
  }
};


// 4. Also update the useEffect that auto-adds default services to NOT run for existing bills:

// Replace this useEffect:
useEffect(() => {
  const hasMeaningfulItems = (items = []) => {
    if (!Array.isArray(items) || items.length === 0) return false;
    return items.some(it => {
      const name = (it && (it.ipd_bill_item_service || it.ot_item_name || '')).toString().trim();
      const finalVal = Number(it && it.ipd_bill_item_final || 0);
      return !!name || finalVal > 0 || !!it.ipd_bill_item_id || !!it.isBedItem;
    });
  };

  // ✅ KEY FIX: Don't auto-add defaults if bill already exists (has ipd_bill_id)
  if (formData.ipd_bill_id) {
    console.log("Existing bill detected - skipping auto-add defaults");
    return;
  }
  
  if (hasMeaningfulItems(formData.otitems)) {
    console.log("Items already exist - skipping auto-add defaults");
    return;
  }

  (async () => {
    try {
      console.log('Auto-merge defaults: fetching default services...');
      const defaults = await fetchDefaultServices();
      if (defaults && defaults.length > 0) {
        console.log('Auto-merge defaults: merging', defaults.length);
        mergeDefaultServicesIntoBill(defaults);
      } else {
        console.warn('Auto-merge defaults: no defaults returned');
      }
    } catch (err) {
      console.error('Auto-merge defaults error', err);
    }
  })();
}, [
  formData.services?.length,
  formData.ipd_bill_id,
  formData.otitems
]);


// 5. Make sure your AppConst.js has:
// getIpdBillItemsUrl: '/get_ipd_bill_items',

// ---------- Auto-add default services on new bill ----------
useEffect(() => {
  const hasMeaningfulItems = (items = []) => {
    if (!Array.isArray(items) || items.length === 0) return false;
    return items.some(it => {
      const name = (it && (it.ipd_bill_item_service || it.ot_item_name || '')).toString().trim();
      const finalVal = Number(it && it.ipd_bill_item_final || 0);
      return !!name || finalVal > 0 || !!it.ipd_bill_item_id || !!it.isBedItem;
    });
  };

  // Only auto-add for new bill (no id) and when no meaningful items exist
  if (formData.ipd_bill_id) return;
  if (hasMeaningfulItems(formData.otitems)) return;

  (async () => {
    try {
      console.log('Auto-merge defaults: fetching default services...');
      const defaults = await fetchDefaultServices();
      if (defaults && defaults.length > 0) {
        console.log('Auto-merge defaults: merging', defaults.length);
        mergeDefaultServicesIntoBill(defaults);
        //toast.success(`Added ${defaults.length} default service(s)`);
      } else {
        console.warn('Auto-merge defaults: no defaults returned');
      }
    } catch (err) {
      console.error('Auto-merge defaults error', err);
    }
  })();
}, [
  // run when services list loads or when new bill state changes
  formData.services?.length,
  formData.ipd_bill_id,
  formData.otitems // if otitems changes from prefills
]);
// ---------- calculateNewTotals fallback (only add if you don't already have it) ----------


/* -------------------- 3) mergeDefaultServicesIntoBill -------------------- */
const mergeDefaultServicesIntoBill = (defaultServices = []) => {
  if (!Array.isArray(defaultServices) || defaultServices.length === 0) return;

  setFormData(prev => {
    const prevItems = Array.isArray(prev.otitems) ? [...prev.otitems] : [];
    const existing = new Set(prevItems.map(it => (it.ipd_bill_item_service || it.ot_item_name || '').toString().toLowerCase().trim()));

    const decideDoctorId = (serviceNameLower) => {
      const consultId = String(prev.ipd_bill_concult_doctor || prev.ot_doctor || (typeof otDoctor !== 'undefined' ? otDoctor : "") || "");
      const anesthesiaId = String(prev.ot_anesthesia_doctor || (typeof otAnesthesiaDoctor !== 'undefined' ? otAnesthesiaDoctor : "") || "");
      const asstId = String(prev.ot_asst_doctor || (typeof otAsstDoctor !== 'undefined' ? otAsstDoctor : "") || "");
      const pediatricId = String(prev.ot_pediatric_doctor || (typeof otPediatricDoctor !== 'undefined' ? otPediatricDoctor : "") || "");
    
      if (!serviceNameLower) return "";
    
      if (/surgeon|surgery|surgeon fee|surgeon fees|surgeon charge/.test(serviceNameLower)) return consultId;
      if (/anaesth|anesthesia|anaesthetist|anesthetist/.test(serviceNameLower)) return anesthesiaId;
      if (/asst|assistant|asst\.? surgeon|assistant surgeon/.test(serviceNameLower)) return asstId;
      if (/p[ae]diatric|p[ae]ediatric doctor/.test(serviceNameLower)) return pediatricId;
      if (serviceNameLower.includes('doctor')) return consultId;
      return "";
    };

    const newItems = [...prevItems];

    for (const s of defaultServices) {
      const nameRaw = (s.cat_name || s.name || s.store_item_name || s.service_name || '').toString().trim();
      if (!nameRaw) continue;
      const nameKey = nameRaw.toLowerCase();
      if (existing.has(nameKey)) continue;

      const price = parseFloat(s.cat_price || s.cat_type1 || s.store_price || s.price || 0) || 0;
      const qty = 1;
      const discount = 0;
      const final = (qty * price) - discount;
      const assignedDoctorId = decideDoctorId(nameKey);

      newItems.push({
        ipd_bill_item_service: nameRaw,
        ipd_bill_item_qty: qty,
        ipd_bill_item_charge: price,
        ipd_bill_item_dis: discount,
        ipd_bill_item_final: final,
        isBedItem: false,
        ipd_bill_item_id: s.id || s.cat_id || s.service_id || "",
        ipd_bill_item_doctor: assignedDoctorId,
        ipd_no: prev.ipd_no || '',
        ipd_bill_uhid: prev.ipd_bill_uhid || prev.ot_uhid_no || ''
      });

      existing.add(nameKey);
    }

    let merged = { ...prev, otitems: newItems };
    if (typeof calculateNewTotals === 'function') {
      try { merged = { ...merged, ...calculateNewTotals(merged) }; } catch (e) { console.warn(e); }
    }
    return merged;
  });
};




    const filteredDoctors = formData.doc.filter((doctor) =>
  doctor.fname.toLowerCase().includes(otDocSearch.toLowerCase())
);

const fetchSignConfigData = async () => {
    try {
        let allSignData = {};
        let allPreviews = {};

        await Promise.all(
            formData.departs.map(async (dep) => {
                const fd = new FormData();
                fd.append('sign_department', dep.cat_id + "");
                const res = await axios.post(AppConst.BASE_URL + AppConst.getSignByDepartUrl, fd);
                // console.log(`this is kkkk [${dep.cat_id}] : ${JSON.stringify(res.data)}`);
                if (res.data.status && res.data.sign_dt) {
                    allSignData[dep.cat_id] = res.data.sign_dt;
                    allPreviews[dep.cat_id] = {
                        tech: res.data.sign_dt.sign_tech_sign ? AppConst.BASE_URL + res.data.sign_dt.sign_tech_sign : null,
                        doc: res.data.sign_dt.sign_doc_sign ? AppConst.BASE_URL + res.data.sign_dt.sign_doc_sign : null
                    };
                }
            })
        );

        setFormData(prev => ({
            ...prev,
            selItem: allSignData
        }));

    } catch (error) {
        console.error(error);
    }
};


// console.log("formData:", JSON.stringify(formData.selItem));
     
    const fetchConfigData = async () => {
        try {
          const res = await axios.post(
            `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
          );
    
          if (res.data.status) {
            const data = res.data;
    // console.log("Config Data:", JSON.stringify(data.header_logo));
            setImage(data.header_logo);
            setWatermarkImage(data.logo || ''); // Set watermark image if available
            setFooterImage(data.footer_logo || ''); // Set watermark image if available
       
        } 
    }
        catch (err) {
          console.error("Error fetching config:", err);
        }
      };
    
      useEffect(() => {
        fetchConfigData()
        fetchSignConfigData()
      },[]);
     
// ---------- Auto-add bed item AFTER wards load (Option A) and fallback (Option B) ----------
useEffect(() => {
  // helper: decides whether an item is "meaningful"
  const isMeaningfulItem = (it) => {
    if (!it) return false;
    const name = String(it.ipd_bill_item_service || "").trim();
    const finalVal = Number(it.ipd_bill_item_final || 0);
    // treat item as meaningful if it has a name OR positive final OR an id (server item)
    return !!name || finalVal > 0 || !!it.ipd_bill_item_id || !!it.isBedItem || !!it.bed_ref_id;
  };

  // helper: items already contain bed
  const itemsHaveBed = (items = []) => {
    if (!Array.isArray(items)) return false;
    return items.some(it => it && (
      it.isBedItem ||
      (it.bed_ref_id && String(it.bed_ref_id) !== "") ||
      (String(it.ipd_bill_item_service || "").toLowerCase().includes('bed'))
    ));
  };

  const computeBedDays = (admissionDateStr, now = new Date(), thresholdHours = 1) => {
    if (!admissionDateStr) return 1;
    const admission = new Date(admissionDateStr);
    if (isNaN(admission.getTime())) return 1;
    if (now.getTime() <= admission.getTime()) return 1;
    const dayStart = d => { const x = new Date(d); x.setHours(0,0,0,0); return x; };
    const dayEnd = d => { const x = dayStart(d); x.setDate(x.getDate()+1); return x; };
    let count = 1;
    let cursor = dayStart(admission);
    cursor.setDate(cursor.getDate() + 1);
    while (cursor.getTime() <= now.getTime()) {
      const overlapStart = Math.max(admission.getTime(), cursor.getTime());
      const overlapEnd = Math.min(now.getTime(), dayEnd(cursor).getTime());
      const overlapMs = Math.max(0, overlapEnd - overlapStart);
      const overlapHours = overlapMs / (1000 * 60 * 60);
      if (overlapHours >= thresholdHours) count += 1;
      cursor.setDate(cursor.getDate() + 1);
    }
    return count;
  };

  const doWork = () => {
    try {
      const currentItems = Array.isArray(formData.otitems) ? [...formData.otitems] : [];

      // 1) CLEANUP: remove placeholder/empty rows first
      const cleaned = currentItems.filter(it => isMeaningfulItem(it));
      if (cleaned.length !== currentItems.length) {
        // update state to remove blanks
        setFormData(prev => ({ ...prev, otitems: cleaned }));
      }

      // use cleaned array for the rest of the checks (important!)
      const itemsToUse = cleaned;

      // 2) REQUIRE explicit bed id — don't auto-add if none
      const rawBedId = formData.ipd_bill_bed ?? formData.ipd_bed ?? "";
      const bedId = (rawBedId === null || rawBedId === undefined) ? "" : String(rawBedId).trim();
      if (!bedId || bedId === "0" || bedId.toLowerCase() === "none") {
        // no assigned bed -> do nothing (and we've already cleaned blanks)
        return;
      }

      // 3) If items already have bed, nothing to add
      if (itemsHaveBed(itemsToUse)) return;

      // 4) resolve bed name/price (wards -> formData -> session)
      const bedNameFromWards = (typeof getBedNameById === "function") ? getBedNameById(bedId) : "";
      const bedPriceFromWards = (typeof getBedPriceById === "function") ? getBedPriceById(bedId) : null;
      const fallbackBedName = formData.ipd_bill_bed_name || formData.bed_name || "";
      const fallbackBedPrice = Number(formData.ipd_bill_bed_price || formData.bed_price || 0) || 0;

      let bedName = bedNameFromWards || fallbackBedName || "";
      let bedPrice = (bedPriceFromWards != null && !isNaN(Number(bedPriceFromWards))) ? Number(bedPriceFromWards) : (fallbackBedPrice || null);

      // session fallback, but only as last resort
      if ((!bedName || String(bedName).trim() === "") && sessionStorage.getItem('billing_prefill')) {
        try {
          const p = JSON.parse(sessionStorage.getItem('billing_prefill'));
          bedName = bedName || p?.bed_name || p?.ipd_bed_name || "";
          const pPrice = Number(p?.bed_price || p?.ipd_bed_price || 0) || 0;
          bedPrice = bedPrice || (pPrice > 0 ? pPrice : bedPrice);
        } catch (e) { /* ignore parse */ }
      }

      // 5) FINAL GUARD: require non-empty name and numeric price > 0
      if (!bedName || String(bedName).trim() === "" || bedPrice === null || isNaN(Number(bedPrice)) || Number(bedPrice) <= 0) {
        // don't add bed if price/name missing
        return;
      }

      // 6) Build bed item and prepend
      const admissionRaw = formData.ipd_bill_doa_raw ?? formData.ipd_bill_doa ?? formData.ipd_reg_date ?? "";
      const days = computeBedDays(admissionRaw, new Date(), 1);
      const qty = days >= 1 ? days : 1;
      const bedItem = {
        ipd_bill_item_service: bedName,
        ipd_bill_item_qty: qty,
        ipd_bill_item_charge: Number(bedPrice),
        ipd_bill_item_dis: 0,
        ipd_bill_item_final: Number(qty) * Number(bedPrice),
        isBedItem: true,
        bed_ref_id: bedId,
         ipd_no: formData.ipd_no || '',
        ipd_bill_uhid: formData.ipd_bill_uhid || formData.ot_uhid_no || ''
      };

      // prepend bed item to the cleaned items and update
      setFormData(prev => {
        // recompute existing cleaned list from prev (in case it changed)
        const prevItems = Array.isArray(prev.otitems) ? prev.otitems.filter(isMeaningfulItem) : [];
        const already = prevItems.some(it =>
          it.isBedItem ||
          (it.bed_ref_id && String(it.bed_ref_id) === String(bedId)) ||
          (String(it.ipd_bill_item_service || "").toLowerCase().includes('bed'))
        );
        if (already) return { ...prev, otitems: prevItems };
        return { ...prev, otitems: [bedItem, ...prevItems] };
      });

    } catch (err) {
      // do not break UI
      // console.error('auto-bed effect error', err);
    }
  };

  doWork();
}, [
  formData.wards,
  formData.ipd_bill_bed,
  formData.ipd_bed,
  formData.otitems,
  formData.ipd_bill_bed_name,
  formData.ipd_bill_bed_price,
  formData.ipd_bill_doa,
  formData.ipd_bill_doa_raw,
  formData.ipd_no,
  formData.ipd_bill_uhid,
  formData.ot_uhid_no
]);


// useEffect(() => {
//   (async () => {
//     try {
//       const raw = sessionStorage.getItem('billing_prefill');
//       if (!raw) return;

//       let payload;
//       try { payload = JSON.parse(raw); } catch (err) { payload = null; }

//       if (!payload) {
//         try { sessionStorage.removeItem('billing_prefill'); } catch (e) {}
//         return;
//       }

//       console.log("📋 Read billing_prefill from session:", payload);
//       try { sessionStorage.removeItem('billing_prefill'); } catch (e) {}

//       const safe = (k1, k2, k3, k4) => (payload?.[k1] ?? payload?.[k2] ?? payload?.[k3] ?? payload?.[k4] ?? "");
//       const uhid = payload.ipd_bill_uhid || payload.ipd_uhid || payload.ot_uhid_no || payload.uhid || "";
//       const ipdNo = payload.ipd_id || payload.ipd_no || "";
//       const billId = payload.ipd_bill_id || "";

//       // ✅ Doctor IDs - check multiple field variations
//       const otDocId = safe('ot_doctor', 'ipd_bill_concult_doctor', 'ipd_concult_doctor', 'ipd_ot_doctor');
//       const asstDocId = safe('ot_asst_doctor', 'ipd_asst_doctor', 'ipd_bill_ot_asst_doctor', '');
//       const anesthesiaDocId = safe('ot_anesthesia_doctor', 'ipd_anesthesia_doctor', 'ipd_bill_ot_anesthesia_doctor', '');
//       const pediatricDocId = safe('ot_pediatric_doctor', 'ot_Pediatric_doctor', 'ipd_pediatric_doctor', '');

     

//       // ✅ Advance Amount - check multiple field variations
//       const advanceAmount = Number(
//         payload.ipd_advance ||
//         payload.advance ||
//         payload.ipd_bill_adv_amount ||
//         0
//       );

//       console.log("📋 Advance amount from prefill:", advanceAmount);

//       // Set doctor UI states
//       setOtDoctor(String(otDocId));
//       setOtDocSearch(getDoctorNameById(otDocId) || "");
//       setOtAsstDoctor(String(asstDocId));
//       setOtAsstDocSearch(getDoctorNameById(asstDocId) || "");
//       setOtAnesthesiaDoctor(String(anesthesiaDocId));
//       setOtAnesthesiaDocSearch(getDoctorNameById(anesthesiaDocId) || "");

//       // Prepare simulated user for immediate use
//       const simulatedUser = {
//         ipd_bill_uhid: uhid,
//         lab_reg_uhid: uhid,
//         ot_uhid_no: uhid,
//         ipd_id: ipdNo,
//         ipd_no: ipdNo,
//         ipd_bill_id: billId,
//         ipd_bill_patient_name: safe('ipd_patient_name', 'ipd_bill_patient_name', 'name', 'patient_name'),
//         lab_reg_name: safe('ipd_patient_name', 'ipd_bill_patient_name', 'name', 'patient_name'),
//         ipd_bill_patient_phone: safe('ipd_patient_phone', 'ipd_bill_patient_phone', 'mobile', 'phone'),
//         ipd_bill_patient_address: safe('ipd_patient_address', 'ipd_bill_patient_address', 'address', ''),
//         ipd_bill_patient_age: safe('ipd_patient_age', 'age', 'lab_age', ''),
//         ipd_bill_patient_gender: safe('ipd_patient_gender', 'ipd_bill_patient_gender', 'gender', ''),
//         ipd_bill_bed: safe('ipd_bed', 'bed', 'ipd_bill_bed', ''),
//         ipd_bill_ward: safe('ipd_ward', 'ward', 'ipd_bill_ward', ''),
//         ipd_bill_doa: safe('ipd_reg_date', 'ipd_bill_doa', 'ipd_datetime', 'reg_date'),
//         ipd_reg_date: safe('ipd_reg_date', 'ipd_bill_doa', 'ipd_datetime', 'reg_date'),
//         ipd_datetime: safe('ipd_reg_date', 'ipd_bill_doa', 'ipd_datetime', 'reg_date'),
//         ipd_refer_doctor: safe('ipd_refer_doctor', 'ipd_bill_refered_doctor', '', ''),
        
//         // ✅ Doctor IDs
//         ot_doctor: otDocId,
//         ipd_concult_doctor: otDocId,
//         ipd_bill_concult_doctor: otDocId,
//         ot_asst_doctor: asstDocId,
//         ipd_asst_doctor: asstDocId,
//         ot_anesthesia_doctor: anesthesiaDocId,
//         ipd_anesthesia_doctor: anesthesiaDocId,
//         ot_pediatric_doctor:pediatricDocId,
//         // ✅ Advance Amount
//         ipd_advance: advanceAmount,
//         advance: advanceAmount,
//         ipd_bill_adv_amount: advanceAmount,
//       };

//       // Update formData first
//       setFormData(prev => ({
//         ...prev,
//         ipd_uhid: uhid || prev.ipd_uhid,
//         ipd_no: ipdNo || prev.ipd_no,
//         ot_uhid_no: uhid || prev.ot_uhid_no,
//         ipd_bill_patient_name: simulatedUser.ipd_bill_patient_name || prev.ipd_bill_patient_name,
//         ipd_bill_patient_phone: simulatedUser.ipd_bill_patient_phone || prev.ipd_bill_patient_phone,
//         ipd_bill_patient_address: simulatedUser.ipd_bill_patient_address || prev.ipd_bill_patient_address,
//         ipd_bill_patient_age: simulatedUser.ipd_bill_patient_age || prev.ipd_bill_patient_age,
//         ipd_bill_patient_gender: normalizeGender(simulatedUser.ipd_bill_patient_gender) || prev.ipd_bill_patient_gender,
//         ipd_bill_bed: simulatedUser.ipd_bill_bed || prev.ipd_bill_bed,
//         ipd_bill_ward: simulatedUser.ipd_bill_ward || prev.ipd_bill_ward,
//         ipd_bill_doa: simulatedUser.ipd_bill_doa || prev.ipd_bill_doa,
//         ipd_bill_refered_doctor: simulatedUser.ipd_refer_doctor || prev.ipd_bill_refered_doctor,
        
//         // ✅ Set doctor IDs
//         ipd_bill_concult_doctor: String(otDocId) || prev.ipd_bill_concult_doctor,
//         ot_asst_doctor: String(asstDocId) || prev.ot_asst_doctor,
//         ot_anesthesia_doctor: String(anesthesiaDocId) || prev.ot_anesthesia_doctor,
//         ot_pediatric_doctor: String(pediatricDocId) || prev.ot_pediatric_doctor,
        
//         // ✅ Set advance amount
//         ipd_bill_adv_amount: advanceAmount || prev.ipd_bill_adv_amount,
//       }));

//       // ✅ CRITICAL: Fetch transaction history IMMEDIATELY
//       if (uhid || billId) {
//         console.log("📋 Fetching transaction history from billing_prefill:", { uhid, billId });
//         await fetchTransactionHistory(uhid || billId);
//       }

//       const isExistingPatient = payload.force_load_existing || payload.is_existing_patient || !!billId;

//       if (isExistingPatient) {
//         console.log("📋 Loading existing patient data with simulated user:", simulatedUser);
//         await handleSelectOtUser(simulatedUser);
//       }

//     } catch (err) {
//       console.error('Error processing billing_prefill', err);
//     }
//   })();
// }, []); // runs once on mount
  
  
  
  // runs once on mount
   
 // ============================================
// FIXED useEffect for IpdBilling.js 
// This reads billing_prefill from sessionStorage
// Replace the existing useEffect (around line 980) with this version
// ============================================

useEffect(() => {
  (async () => {
    try {
      const raw = sessionStorage.getItem('billing_prefill');
      if (!raw) return;

      let payload;
      try { payload = JSON.parse(raw); } catch (err) { payload = null; }

      if (!payload) {
        try { sessionStorage.removeItem('billing_prefill'); } catch (e) {}
        return;
      }

      console.log("📋 Read billing_prefill from session:", payload);
      try { sessionStorage.removeItem('billing_prefill'); } catch (e) {}

      // Helper function to safely get value from multiple keys
      const safe = (...keys) => {
        for (const k of keys) {
          if (k && payload?.[k] !== undefined && payload?.[k] !== null && payload?.[k] !== "") {
            return payload[k];
          }
        }
        return "";
      };

      const uhid = payload.ipd_bill_uhid || payload.ipd_uhid || payload.ot_uhid_no || payload.uhid || "";
      const ipdNo = payload.ipd_id || payload.ipd_no || "";
      const billId = payload.ipd_bill_id || "";
const ipd_case = payload.ipd_case||"";
      // ✅ Extract ALL doctor IDs using the safe helper
      const otDocId = safe(
        'ot_doctor', 
        'ipd_bill_concult_doctor', 
        'ipd_concult_doctor', 
        'ipd_ot_doctor'
      );
      
      // ✅ FIXED: Assistant doctor - check all field variations
      const asstDocId = safe(
        'ot_asst_doctor', 
        'ipd_asst_doctor', 
        'ipd_bill_ot_asst_doctor', 
        'asst_doctor'
      );
      
      const anesthesiaDocId = safe(
        'ot_anesthesia_doctor', 
        'ipd_anesthesia_doctor', 
        'ipd_bill_ot_anesthesia_doctor',
        'anesthesia_doctor'
      );
      
      // ✅ FIXED: Pediatric doctor - check all field variations including capital P
      const pediatricDocId = safe(
        'ot_pediatric_doctor', 
        'ot_Pediatric_doctor',  // Capital P
        'ipd_pediatric_doctor', 
        'ipd_bill_ot_pediatric_doctor',
        'pediatric_doctor'
      );

      // Broker info
      const brokerIdFromPrefill = safe('ipd_broker_id', 'broker_id');
      const brokerNameFromPrefill = safe('ipd_broker_name', 'broker_name');
      const policyNameFromPrefill = safe('ipd_policy_name', 'policy_name');

      console.log("📋 Extracted doctor IDs:", {
        otDocId,
        asstDocId,
        anesthesiaDocId,
        pediatricDocId
      });

      const advanceAmount = Number(
        payload.ipd_advance ||
        payload.advance ||
        payload.ipd_bill_adv_amount ||
        0
      );

      // ✅ Set ALL doctor UI states
      if (otDocId) {
        setOtDoctor(String(otDocId));
        setOtDocSearch(getDoctorNameById(otDocId) || "");
      }
      if (asstDocId) {
        setOtAsstDoctor(String(asstDocId));
        setOtAsstDocSearch(getDoctorNameById(asstDocId) || "");
        console.log("✅ Set Assistant Doctor:", asstDocId);
      }
      if (anesthesiaDocId) {
        setOtAnesthesiaDoctor(String(anesthesiaDocId));
        setOtAnesthesiaDocSearch(getDoctorNameById(anesthesiaDocId) || "");
      }
      if (pediatricDocId) {
        setOtPediatricDoctor(String(pediatricDocId));
        setOtPediatricDocSearch(getDoctorNameById(pediatricDocId) || "");
        console.log("✅ Set Pediatric Doctor:", pediatricDocId);
      }

      // Build simulated user object
      const simulatedUser = {
        ipd_bill_uhid: uhid,
        lab_reg_uhid: uhid,
        ot_uhid_no: uhid,
        ipd_id: ipdNo,
        ipd_no: ipdNo,
        ipd_bill_id: billId,
        ipd_bill_patient_name: safe('ipd_patient_name', 'ipd_bill_patient_name', 'name', 'patient_name'),
        lab_reg_name: safe('ipd_patient_name', 'ipd_bill_patient_name', 'name', 'patient_name'),
        ipd_bill_patient_phone: safe('ipd_patient_phone', 'ipd_bill_patient_phone', 'mobile', 'phone'),
        ipd_bill_patient_address: safe('ipd_patient_address', 'ipd_bill_patient_address', 'address'),
        ipd_bill_patient_age: safe('ipd_patient_age', 'age', 'lab_age'),
        ipd_bill_patient_gender: safe('ipd_patient_gender', 'ipd_bill_patient_gender', 'gender'),
        ipd_bill_bed: safe('ipd_bed', 'bed', 'ipd_bill_bed'),
        ipd_bill_ward: safe('ipd_ward', 'ward', 'ipd_bill_ward'),
        ipd_bill_doa: safe('ipd_reg_date', 'ipd_bill_doa', 'ipd_datetime', 'reg_date'),
        ipd_reg_date: safe('ipd_reg_date', 'ipd_bill_doa', 'ipd_datetime', 'reg_date'),
        ipd_datetime: safe('ipd_reg_date', 'ipd_bill_doa', 'ipd_datetime', 'reg_date'),
        ipd_refer_doctor: safe('ipd_refer_doctor', 'ipd_bill_refered_doctor'),
        ipd_case: safe('ipd_case'),
        // ✅ ALL Doctor IDs
        ot_doctor: otDocId,
        ipd_concult_doctor: otDocId,
        ipd_bill_concult_doctor: otDocId,
        ot_asst_doctor: asstDocId,
        ipd_asst_doctor: asstDocId,
        ot_anesthesia_doctor: anesthesiaDocId,
        ipd_anesthesia_doctor: anesthesiaDocId,
        ot_pediatric_doctor: pediatricDocId,
        ot_Pediatric_doctor: pediatricDocId,
        ipd_pediatric_doctor: pediatricDocId,
        
        // Broker Info
        ipd_broker_id: brokerIdFromPrefill,
        broker_id: brokerIdFromPrefill,
        ipd_broker_name: brokerNameFromPrefill,
        broker_name: brokerNameFromPrefill,

        ipd_policy_name: policyNameFromPrefill,
        policy_name: policyNameFromPrefill,
        // Advance Amount
        ipd_advance: advanceAmount,
        advance: advanceAmount,
        ipd_bill_adv_amount: advanceAmount,
      };

      // Update formData
      setFormData(prev => ({
        ...prev,
        ipd_uhid: uhid || prev.ipd_uhid,
        ipd_no: ipdNo || prev.ipd_no,
        ot_uhid_no: uhid || prev.ot_uhid_no,
        ipd_bill_patient_name: simulatedUser.ipd_bill_patient_name || prev.ipd_bill_patient_name,
        ipd_bill_patient_phone: simulatedUser.ipd_bill_patient_phone || prev.ipd_bill_patient_phone,
        ipd_bill_patient_address: simulatedUser.ipd_bill_patient_address || prev.ipd_bill_patient_address,
        ipd_bill_patient_age: simulatedUser.ipd_bill_patient_age || prev.ipd_bill_patient_age,
        ipd_bill_patient_gender: normalizeGender(simulatedUser.ipd_bill_patient_gender) || prev.ipd_bill_patient_gender,
        ipd_bill_bed: simulatedUser.ipd_bill_bed || prev.ipd_bill_bed,
        ipd_bill_ward: simulatedUser.ipd_bill_ward || prev.ipd_bill_ward,
        ipd_bill_doa: simulatedUser.ipd_bill_doa || prev.ipd_bill_doa,
        ipd_bill_refered_doctor: simulatedUser.ipd_refer_doctor || prev.ipd_bill_refered_doctor,
        ipd_case: simulatedUser.ipd_case,
        ipd_policy_name: policyNameFromPrefill || prev.ipd_policy_name,
        // ✅ Set ALL doctor IDs in formData
        ipd_bill_concult_doctor: String(otDocId) || prev.ipd_bill_concult_doctor,
        ot_asst_doctor: String(asstDocId) || prev.ot_asst_doctor,
        ot_anesthesia_doctor: String(anesthesiaDocId) || prev.ot_anesthesia_doctor,
        ot_pediatric_doctor: String(pediatricDocId) || prev.ot_pediatric_doctor,
        
        // Broker info
        ipd_broker_id: brokerIdFromPrefill || prev.ipd_broker_id,
        ipd_broker_name: brokerNameFromPrefill || prev.ipd_broker_name,
        broker_id: brokerIdFromPrefill || prev.broker_id,
        broker_name: brokerNameFromPrefill || prev.broker_name,
        
        // Advance amount
        ipd_bill_adv_amount: advanceAmount || prev.ipd_bill_adv_amount,
      }));
      setPolicyName(policyNameFromPrefill);
      // Fetch transaction history
      if (uhid || billId) {
        console.log("📋 Fetching transaction history:", { uhid, billId });
        await fetchTransactionHistory(uhid || billId);
      }

      const isExistingPatient = payload.force_load_existing || payload.is_existing_patient || !!billId;

      if (isExistingPatient) {
        console.log("📋 Loading existing patient data:", simulatedUser);
        await handleSelectOtUser(simulatedUser);
      }

    } catch (err) {
      console.error('Error processing billing_prefill', err);
    }
  })();
}, []); // runs once on mount
  useEffect(() => {
  const onDocClick = (ev) => {
    const insideInput = serviceSearchRef.current && serviceSearchRef.current.contains(ev.target);
    const insideList  = serviceListRef.current && serviceListRef.current.contains(ev.target);
    if (!insideInput && !insideList) {
      setShowServices(false);
    }
  };
  document.addEventListener("mousedown", onDocClick);
  return () => document.removeEventListener("mousedown", onDocClick);
}, []);
 
const imageUrlToBase64 = async (url) => {
    // Check if the URL is valid
    if (!url) {
        console.error("imageUrlToBase64: Provided URL is empty or invalid.");
        return null;
    }

    // NEW: Added detailed logging to debug image loading issues.
    // console.log("Attempting to fetch image from URL:", url);

    try {
        const response = await fetch(url, { cache: 'no-cache' }); // Added no-cache to prevent browser caching issues
        if (!response.ok) {
            console.error(`Failed to fetch image. URL: ${url}, Status: ${response.status} ${response.statusText}`);
            return null;
        }
        
        const blob = await response.blob();
    
        if (!blob.type.startsWith('image/')) {
            console.error(`The URL did not point to an image. URL: ${url}, MIME Type: ${blob.type}`);
            return null;
        }
    
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = (error) => {
                console.error("FileReader error:", error);
                reject(error);
            };
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        // This error often happens due to CORS (Cross-Origin Resource Sharing) policy.
        // Make sure your server allows images to be fetched from the domain where this script is running.
        console.error("Error fetching or converting image. This might be a CORS issue.", { url, error });
        return null;
    }
};


const handleOtDocSelect = (doctorId) => {
  setFormData({
    ...formData,
    ipd_bill_concult_doctor: doctorId,   // doctor id save hogi
  });
  
  // id se name nikalo
  const selectedDoctor = filteredDoctors.find(doc => doc.user_id === doctorId);
  setOtDocSearch(selectedDoctor ? selectedDoctor.fname : "");

  setShowOtDocOptions(false); // dropdown band ho jayega
};
const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
};
function formatDate2(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;
  const day = String(date.getDate()).padStart(2, '0');
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}
const amountInWords = (amount) => {
    // ... (amountInWords ka poora code yahan paste karein, koi change nahi hai)
    // For brevity, I am not repeating the full function here.
    const num = parseFloat(amount);
    if (isNaN(num) || num === 0) return 'Zero';
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const convertLessThanThousand = (n) => {
        if (n === 0) return '';
        let res = '';
        const hundreds = Math.floor(n / 100);
        if (hundreds > 0) { res += units[hundreds] + ' Hundred '; n %= 100; }
        if (n > 0) {
            if (res !== '') res += 'and ';
            if (n < 10) { res += units[n]; }
            else if (n < 20) { res += teens[n - 10]; }
            else { res += tens[Math.floor(n / 10)]; if (n % 10 > 0) { res += ' ' + units[n % 10]; } }
        }
        return res.trim();
    };
    let result = '', n = Math.floor(num);
    const crores = Math.floor(n / 10000000);
    if (crores > 0) { result += convertLessThanThousand(crores) + ' Crore '; n %= 10000000; }
    const lakhs = Math.floor(n / 100000);
    if (lakhs > 0) { result += convertLessThanThousand(lakhs) + ' Lakh '; n %= 100000; }
    const thousands = Math.floor(n / 1000);
    if (thousands > 0) { result += convertLessThanThousand(thousands) + ' Thousand '; n %= 1000; }
    result += convertLessThanThousand(n);
    return result.trim();
};

const addHeaderAndFooter = async (doc) => {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // ===== Watermark =====
    const watermarkBase64 = await imageUrlToBase64(watermarkImage);
    if (watermarkBase64) {
        doc.setGState(new doc.GState({ opacity: 0.08 }));
        doc.addImage(watermarkBase64, 'PNG', (pageWidth - 120) / 2, (pageHeight - 120) / 2, 120, 120);
        doc.setGState(new doc.GState({ opacity: 1 }));
    }

    // ===== Header Image =====
    const headerImageBase64 = await imageUrlToBase64(image);
    if (headerImageBase64) {
        doc.addImage(headerImageBase64, 0, 0, pageWidth, 30);
    }

    // ===== Footer Image =====
    const footerImageBase64 = await imageUrlToBase64(footerImage);
    if (footerImageBase64) {
        doc.addImage(footerImageBase64, 0, pageHeight - 13, pageWidth, 13);
    }
};


const handleChange = (e) => {
    const { name, value } = e.target;

     if (name === "ipd_bill_paid") {
    const paid = Number(value);
    setPaidChanged(true); 
    // const due = Number(formData.ipd_bill_due);
    setIsFinalized(false)

if (paid > (Number(formData.ipd_bill_due) + Number(formData.ipd_bill_paid))) {
  toast.error("Paid amount cannot be greater than Due amount!");
  return;
}


  }

    setFormData(prev => {
        // 1. Nayi value ke saath ek temporary state banayein
        const nextState = { ...prev, [name]: value };

        // 2. Is temporary state par saare totals dobara calculate karein
        const newTotals = calculateNewTotals(nextState);

        // 3. Dono ko milakar state mein ek saath update karein
        return { ...nextState, ...newTotals };
    });

    if (name === "search_key") {
        initData();
    }
};

// UPDATED handleChange1 function
// This function updates the state when you edit any service item
const handleChange1 = (e, index) => {
    const { name, value } = e.target;
    // This removes the index from the name to get the property key (e.g., "ipd_bill_item_qty")
    const baseName = name.replace(/\d+$/, '');

    setFormData(prev => {
        const newOtItems = [...prev.otitems];
        const updatedItem = { ...newOtItems[index], [baseName]: value };

        // Recalculate the final price for the item being edited
        const qty = parseFloat(updatedItem.ipd_bill_item_qty) || 0;
        const charge = parseFloat(updatedItem.ipd_bill_item_charge) || 0;
        const discount = parseFloat(updatedItem.ipd_bill_item_dis) || 0;
        updatedItem.ipd_bill_item_final = (qty * charge) - discount;

        newOtItems[index] = updatedItem;

        return {
            ...prev,
            otitems: newOtItems
        };
    });
};
// Adds a service object into otitems and recalculates totals immediately.
// Place this near your other handlers (e.g. after handleAddService).
const addServiceToItems = (srv) => {
  if (!srv) return;
  
  setFormData(prev => {
    const serviceName = (srv.cat_name || srv.name || srv.service_name || "").toLowerCase().trim();
    const unitCharge = Number(srv.cat_price ?? srv.cat_type1 ?? srv.price ?? 0);
    const qty = 1;
    const discount = 0;
    const final = (qty * unitCharge) - discount;

    // Determine which doctor ID to assign based on service name
    let assignedDoctorId = "";
    
    // Surgeon Fees / Paediatric Doctor / OT Surgeon -> OT Doctor
    if (serviceName.includes('surgeon fees') || 
        serviceName.includes('surgeon fee') || 
        serviceName.includes('ot surgeon') ||
        serviceName.includes('surgery fee') ||
        serviceName.includes('surgeon charge')) {
      assignedDoctorId = prev.ipd_bill_concult_doctor || otDoctor || "";
    } 

    else if (serviceName.includes('Paediatric Doctor') ||
             serviceName.includes('pediatric doctor') ||
             serviceName.includes('paediatric') ||
             serviceName.includes('pediatric')) {
      assignedDoctorId = prev.ot_pediatric_doctor || otPediatricDoctor || "";
    }
    // Anaesthesia -> Anesthesia Doctor
    else if (serviceName.includes('anaesthesia') || 
             serviceName.includes('Anaesthesia') ||
             serviceName.includes('Anaesthesia Doctor') ||
             serviceName.includes('anesthetist')) {
      assignedDoctorId = prev.ot_anesthesia_doctor || otAnesthesiaDoctor || "";
    } 


    
    // Asst. Surgeon -> Asst. OT Doctor
    else if (serviceName.includes('asst. surgeon') || 
             serviceName.includes('asst surgeon') ||
             serviceName.includes('assistant surgeon') ||
             serviceName.includes('Asst. Doctor') ||
             serviceName.includes('assistant doctor')) {
      assignedDoctorId = prev.ot_asst_doctor || otAsstDoctor || "";
    }

    const newItem = {
      ipd_bill_item_service: srv.cat_name || srv.name || srv.service_name || "",
      ipd_bill_item_qty: qty,
      ipd_bill_item_charge: unitCharge,
      ipd_bill_item_dis: discount,
      ipd_bill_item_final: final,
      isBedItem: false,
      ipd_bill_item_id: srv.id || srv.cat_id || srv.service_id || "",
      // DOCTOR ID FOR THIS SERVICE ITEM
      ipd_bill_item_doctor: assignedDoctorId,
       ipd_no: prev.ipd_no || '',
      ipd_bill_uhid: prev.ipd_bill_uhid || prev.ot_uhid_no || ''
    };

    const newOtItems = [...(prev.otitems || []), newItem];
    const updatedState = { ...prev, otitems: newOtItems };
    const totals = calculateNewTotals(updatedState);

    return { ...updatedState, ...totals, search_key: "" };
  });

  setShowServices(false);
};

// This function adds a new, empty, and fully editable service row



//from here pdf , lab, pharmacy, gatepass etc all    


const handleAddService = () => {
    const newServiceItem = {
        ipd_bill_item_service: "",
        ipd_bill_item_qty: 1,
        ipd_bill_item_charge: 0,
        ipd_bill_item_dis: 0,
        ipd_bill_item_final: 0,
        isBedItem: false // Not a bed item, so it will be editable
    };

    setFormData(prev => ({
        ...prev,
        otitems: [...prev.otitems, newServiceItem]
    }));
};


const calculateNewTotals = (currentFormData) => {
  const items = currentFormData.otitems || [];
  const sumItemFinals = items.reduce((sum, item) => sum + (parseFloat(item.ipd_bill_item_final) || 0), 0);

  const discountPerc = parseFloat(currentFormData.ipd_bill_discount) || 0;
  const fixedDeposit = parseFloat(currentFormData.ipd_bill_fixed_deposit) || 0;
  const advAmount = parseFloat(currentFormData.ipd_bill_adv_amount) || 0;
  const paid = parseFloat(currentFormData.ipd_bill_paid) || 0;

  const amountAfterPercentDiscount = sumItemFinals - (sumItemFinals * discountPerc / 100);
  const finalAmount = amountAfterPercentDiscount - fixedDeposit;
  const due = finalAmount - advAmount - paid;

  return {
      ipd_bill_total_amt: sumItemFinals.toFixed(2),
      ipd_bill_final_amt: finalAmount.toFixed(2),
      ipd_bill_due: due.toFixed(2)
  };
};



  const handleAddDepart = () => {
    formData.page_no = 0;
  };


    useEffect(() => {
    const newTotals = calculateNewTotals(formData);
    setFormData((prev) => ({
      ...prev,
      ...newTotals, // ipd_bill_total_amt, ipd_bill_final_amt, ipd_bill_due auto update ho jayenge
    }));
  }, [
    formData.otitems,
    formData.ipd_bill_discount,
    formData.ipd_bill_fixed_deposit,
    formData.ipd_bill_adv_amount,
    formData.ipd_bill_paid,
  ]);




  
<div className="billing-tabs-wrapper mb-4">
  <nav className="billing-tabs" role="tablist" aria-label="Billing tabs">
    <button
      role="tab"
      aria-selected={activeTab === 'lab'}
      className={`billing-tab ${activeTab === 'lab' ? 'active' : ''}`}
      onClick={() => handleTabClick('lab')}
      onKeyDown={(e) => { if (e.key === 'Enter') setActiveTab('lab'); }}
    >
      <div className="tab-title">Lab Billing</div>
      <div className="tab-sub">Summary & invoices</div>
      {Number(duePayment) > 0 && (
        <span className="tab-badge">Due ₹{Number(duePayment).toFixed(0)}</span>
      )}
    </button>

    <button
      role="tab"
      aria-selected={activeTab === 'pharmacy'}
      className={`billing-tab ${activeTab === 'pharmacy' ? 'active' : ''}`}
      onClick={() => handleTabClick('pharmacy')}
      onKeyDown={(e) => { if (e.key === 'Enter') setActiveTab('pharmacy'); }}
    >
      <div className="tab-title">Pharmacy Billing</div>
      <div className="tab-sub">Medicines & issues</div>
      {Number(pharmacyDue) > 0 && (
        <span className="tab-badge">Due ₹{Number(pharmacyDue).toFixed(0)}</span>
      )}
    </button>

    <button
      role="tab"
      aria-selected={activeTab === 'store'}
      className={`billing-tab ${activeTab === 'store' ? 'active' : ''}`}
      onClick={() => handleTabClick('store')}
      onKeyDown={(e) => { if (e.key === 'Enter') setActiveTab('store'); }}
    >
      <div className="tab-title">Store</div>
      <div className="tab-sub">Consumables & stock</div>
    </button>
  </nav>

  <div className="billing-tab-panel mt-3" role="tabpanel">
    {activeTab === 'lab' && (
      <div>
        {/* Use your existing Lab body (sections[0] style). Minimal example: */}
        <div className="row">
          <div className="col-md-8">
            <h6 className="mb-2">Lab details</h6>
            {/* show summary */}
            <div className="d-flex gap-3 mb-2">
              <div>Final: ₹{Number(finalPayment).toFixed(2)}</div>
              {/* <div>Paid: ₹{Number(paidPayment).toFixed(2)}</div> */}
              <div>Due: ₹{Number(duePayment).toFixed(2)}</div>
            </div>
          </div>
          <div className="col-md-4 text-end">
            <button className="btn btn-outline-secondary me-2" onClick={() => ensureSavedThen(() => {/* open pharmacy details */})}>View</button>
            <button className="btn btn-dark" onClick={() => ensureSavedThen(() => {/* open pharmacy details */})}>Print Lab Summary</button>
          </div>
        </div>
      </div>
    )}

    {activeTab === 'pharmacy' && (
      <div>
        <div className="row">
          <div className="col-md-8">
            <h6 className="mb-2">Pharmacy details</h6>
            <div className="d-flex gap-3 mb-2">
              <div>Final: ₹{Number(pharmacyFinal || 0).toFixed(2)}</div>
              {/* <div>Paid: ₹{Number(pharmacyPaid || 0).toFixed(2)}</div> */}
              <div>Due: ₹{Number(pharmacyDue || 0).toFixed(2)}</div>
            </div>
          </div>
          <div className="col-md-4 text-end">
            <button className="btn btn-outline-secondary me-2" onClick={() => ensureSavedThen(() => {/* open pharmacy details */})}>View</button>
            <button className="btn btn-dark" onClick={async () => {
              // optionally run the same due-check before printing pharmacy slip
              const { lab, pharmacy } = await checkExternalDues(formData.ipd_bill_uhid);
              if (Number(pharmacy.due || 0) > 0) {
                await Swal.fire({ icon: 'warning', title: 'Pharmacy Due', text: `There is a pharmacy due of ₹${Number(pharmacy.due).toFixed(2)}.` });
                return;
              }
              // your pharmacy print handler (if any)
            }}>Print Pharmacy</button>
          </div>
        </div>
      </div>
    )}

    {activeTab === 'store' && (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h6 className="mb-2">Store</h6>
            <p className="text-muted">Consumables, transfers and stock summary.</p>
            {/* put store body here */}
          </div>
        </div>
      </div>
    )}
  </div>
</div>




const generatePDF = async (formData, options = {}) => {
  const {
    includeHeader = true,
    includeLab = true,
    includePharmacy = true
  } = options;

  const doc = new jsPDF();
  let y = 0;

  // ===== HEADER (WITH OR WITHOUT IMAGE) =====
  if (includeHeader) {
    try {
      const headerImageBase64 = await imageUrlToBase64(image);
      if (headerImageBase64) {
        const pageWidth = doc.internal.pageSize.getWidth();
        const height = 30;
        doc.addImage(headerImageBase64, "PNG", 0, y, pageWidth, height);
      }
    } catch (error) {
      console.error("Could not add header image:", error);
    }
    // ✅ ALWAYS reserve header space (with or without image)
    y = 38; 
  } else {
    // ✅ NO HEADER: Reserve space but don't add image
    y = 38; // Same spacing as with header
  }

  const headerColor = [180, 220, 250];
  // ... rest of PDF generation

  // ==== Header Section with Barcode ====
  const uhid = formData.ipd_bill_uhid || formData.ot_uhid_no || '';
  let barcodeDataUrl = uhid;

  if (uhid) {
    try {
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, String(uhid), {
        format: 'CODE128',
        displayValue: false,
        height: 25,
        margin: 0
      });
      barcodeDataUrl = canvas.toDataURL('image/png');
    } catch (err) {
      console.warn("barcode error:", err);
    }
  }

  autoTable(doc, {
    startY: y,
    body: [[
      `UHID No : ${uhid}\n` +
      `Patient : ${formData.ipd_bill_patient_name || ''}\n` +
      `Age/Gender : ${formData.ipd_bill_patient_age || ''} / ${formData.ipd_bill_patient_gender || ''}\n` +
      `Address : ${formData.ipd_bill_patient_address || ''}\n` +
      `Referred Doctor : ${getDoctorNameById(formData.ipd_bill_refered_doctor) || ''}\n`,

      `IPD No : 000${formData.ipd_bill_id || ''}\n` +
      `Admission Date : ${formatDateTime12h(formData.ipd_bill_doa)}\n` +
      `Billing Date : ${formatDateTime12h(formData.ipd_bill_date)}\n` +
      `Bed : ${getBedNameById(formData.ipd_bill_bed) || ''}\n` +
      `Ward : ${getWardNameById(formData.ipd_bill_ward) || ''}\n` +
      `Insurance : ${formData.ipd_policy_name || 'N/A'}\n`,
    ]],
    theme: 'grid',
    styles: { fontSize: 10, cellPadding: 2, lineColor: [0, 0, 0], textColor: [0, 0, 0], lineWidth: 0.3 },
    columnStyles: {
      0: { cellWidth: 110 },
      1: { cellWidth: 70 }
    },
    didDrawCell: function (data) {
      if (data.section === 'body' && data.column.index === 0 && data.row.index === 0 && barcodeDataUrl) {
        const cell = data.cell;
        const imgW = 34;
        const imgH = 7;
        const imgX = cell.x + 73;
        const imgY = cell.y + 2;
        try {
          doc.addImage(barcodeDataUrl, 'PNG', imgX, imgY, imgW, imgH);
        } catch (err) {
          console.warn('addImage error', err);
        }
      }
    }
  });

  y = doc.lastAutoTable.finalY + 2;

  // ==== LAB BILLING (CONDITIONAL) ====
  if (includeLab && Number(finalPayment) > 0) {
    doc.setFontSize(10).setFont('helvetica', 'bold');

    autoTable(doc, {
      startY: y + 3,
      head: [['Lab Details']],
      body: [[{
        content: `Total Amount: ${Number(finalPayment).toFixed(2)}`,
                
        styles: { halign: 'left' }
      }]],
      theme: 'plain',
      headStyles: { fillColor: headerColor, textColor: 0, fontStyle: 'bold', halign: 'left' },
      styles: { fontSize: 9, cellPadding: 1.5, lineColor: [0, 0, 0], lineWidth: 0.1 }
    });

    y = doc.lastAutoTable.finalY + 2;
  }

  // ==== PHARMACY BILLING (CONDITIONAL) ====
  if (includePharmacy && Number(pharmacyFinal) > 0) {
    doc.setFontSize(10).setFont('helvetica', 'bold');

    autoTable(doc, {
      startY: y + 3,
      head: [['Pharmacy Details']],
      body: [[{
        content: `Total Amount: ${Number(pharmacyFinal).toFixed(2)}`,
                
        styles: { halign: 'left' }
      }]],
      theme: 'plain',
      headStyles: { fillColor: headerColor, textColor: 0, fontStyle: 'bold', halign: 'left' },
      styles: { fontSize: 9, cellPadding: 1.5, lineColor: [0, 0, 0], lineWidth: 0.1 }
    });

    y = doc.lastAutoTable.finalY + 6;
  }

  // ==== Transaction History ====
  doc.setFontSize(10).setFont('helvetica', 'bold');
  doc.text("IPD Payment History", 14, y+2);

  const transactionData = transactionHistory.length > 0
    ? transactionHistory.map((item, index) => [
        index + 1,
        formatDate(item.payment_datetime),
        parseFloat(item.payment_amount).toFixed(2),
        item.payment_method || 'N/A',
        item.received_by_name && item.received_by_name.trim() !== ''
          ? item.received_by_name
          : `User #${item.received_by}`
      ])
    : [['', 'No Record Found', '', '', '']];

  autoTable(doc, {
    startY: y + 4,
    head: [['Sl.No', 'Date', 'Amount', 'Payment Method', 'Received By']],
    body: transactionData,
    theme: 'grid',
    headStyles: { fillColor: headerColor, textColor: 0, fontStyle: 'bold' },
    styles: { fontSize: 9, cellPadding: 1.5, textColor: 0, lineColor: [0, 0, 0], lineWidth: 0.2 }
  });

  y = doc.lastAutoTable.finalY + 9;

  // ==== IPD Billing Details ====
  doc.setFontSize(10).setFont('helvetica', 'bold');
  doc.text("IPD Billing Details", 14, y);

  const ipdData = formData.otitems.map((item, index) => [
    index + 1,
    item.ipd_bill_item_service || 'N/A',
    item.ipd_bill_item_qty || 1,
    parseFloat(item.ipd_bill_item_charge || 0).toFixed(2),
    parseFloat(item.ipd_bill_item_dis || 0).toFixed(2),
    parseFloat(item.ipd_bill_item_final || 0).toFixed(2),
  ]);

  const total = parseFloat(formData.ipd_bill_total_amt || 0);
  const discountPercent = parseFloat(formData.ipd_bill_discount || 0);
  const discountAmount = parseFloat(formData.ipd_bill_fixed_deposit) || (total * discountPercent / 100);

  autoTable(doc, {
    startY: y + 2,
    head: [['Sl.No', 'Particular of Services', 'Qty', 'Price', 'Discount', 'Amount']],
    body: ipdData,
    theme: 'grid',
    headStyles: { fillColor: headerColor, textColor: 0, fontStyle: 'bold' },
    styles: { fontSize: 9, cellPadding: 1.5, textColor: 0, lineColor: 0, lineWidth: 0.2 },
    columnStyles: {
      0: { halign: 'center' },
      2: { halign: 'center' },
      3: { halign: 'right' },
      4: { halign: 'right' },
      5: { halign: 'right' }
    }
  });

  y = doc.lastAutoTable.finalY + 8;

  // ==== Summary ====
  doc.setFontSize(10).setFont('helvetica', 'normal');
  const rightX = 190;
  const labelX = 140;

  doc.text("Total Amount :", labelX, y);
  doc.text(total.toFixed(2), rightX, y, { align: 'right' });
  y += 6;

  doc.text("Discount Amt :", labelX, y);
  doc.text(discountAmount.toFixed(2), rightX, y, { align: 'right' });
  y += 6;

  doc.text("Final Amount :", labelX, y);
  doc.text(parseFloat(formData.ipd_bill_final_amt || 0).toFixed(2), rightX, y, { align: 'right' });
  y += 6;

  doc.text("Advance :", labelX, y);
  doc.text(parseFloat(formData.ipd_bill_adv_amount || 0).toFixed(2), rightX, y, { align: 'right' });
  y += 6;

  doc.text("Due :", labelX, y);
  doc.text(parseFloat(formData.ipd_bill_due || 0).toFixed(2), rightX, y, { align: 'right' });
  y += 6;

  doc.text("Paid :", labelX, y);
  doc.text(parseFloat(formData.ipd_bill_paid || 0).toFixed(2), rightX, y, { align: 'right' });
  y += 10;

  doc.setFontSize(9).setFont('helvetica', 'bold');
  const finalAmountInWords = amountInWords(formData.ipd_bill_final_amt || 0) + ' only';
  doc.text(`AMOUNT IN WORDS : ${finalAmountInWords.toUpperCase()}`, 14, y);

  // ==== Footer ====
  const footerY = y + 20;
  const qrText = `UHID: ${formData.ipd_bill_uhid}, Name: ${formData.ipd_bill_patient_name}`;
  const qrCodeDataURL = await QRCode.toDataURL(qrText, { width: 100 });

  doc.addImage(qrCodeDataURL, "PNG", 14, footerY, 19, 19);

  doc.setFontSize(9).setFont('helvetica', 'normal');
  transactionHistory.forEach(item => {
    doc.text(
      `Prepared By: ${item.received_by_name && item.received_by_name.trim() !== ''
        ? item.received_by_name
        : 'User #' + item.received_by}`,
      14,
      footerY + 25
    );
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  doc.setFontSize(9).setFont('helvetica', 'bold');
  doc.text("Authorised Signature", pageWidth - 50, footerY + 25);
  doc.line(pageWidth - 70, footerY + 20, pageWidth - 15, footerY + 20);

  const pdfBlobUrl = doc.output('bloburl');
  window.open(pdfBlobUrl, '_blank');
};



const generateProvisionalBill = async (formData) => {
    // A4 size का नया PDF document बनाएं
    const doc = new jsPDF('p', 'pt', 'a4');

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageCenter = pageWidth / 2;
    let y = 0; // Y-axis पर position को track करने के लिए
 try {
    const headerImageBase64 = await imageUrlToBase64(image);
    if (headerImageBase64) {
        const pageWidth = doc.internal.pageSize.getWidth(); 
        const y = 10; // top margin
        const height = 80; // header image ki height

        // Header image
        doc.addImage(headerImageBase64, "PNG", 0, y, pageWidth, height);

        // ✅ Barcode header ke niche
        try {
          const codeValue = formData.ipd_bill_uhid || formData.ot_uhid_no || "";
          const desiredPdfWidth = 150; // width in PDF units (pt) you want the barcode to occupy
          const desiredPdfHeight = 36; // height in PDF units
        
          // Create a high-res canvas
          const scale = 3; // 2..4 works; higher = crisper but larger image
          const canvas = document.createElement('canvas');
          const baseWidth = 200; // base pixel width at 1x (tweak if needed)
          const baseHeight = 80; // base pixel height at 1x
          canvas.width = baseWidth * scale;
          canvas.height = baseHeight * scale;
          canvas.style.width = `${baseWidth}px`;
          canvas.style.height = `${baseHeight}px`;
        
          // Provide scale to JsBarcode via "scale" option and set height appropriately
          JsBarcode(canvas, codeValue, {
            format: 'CODE128',
            width: 1 * scale,
            height: 60 * scale,
            displayValue: false,   // <<< DISABLE the text under the bars
            margin: 10 * scale,
            flat: true,
            lineColor: '#000'
          });
        
          // Convert to dataURL
          const barcodeDataUrl = canvas.toDataURL('image/png');
        
          // Calculate X to place on PDF (right-aligned like your original code)
          const imgWidth = desiredPdfWidth; // units for doc.addImage
          const imgHeight = desiredPdfHeight;
          const xPos = pageWidth - imgWidth - 14; // 14pt from right margin (adjust)
          const yPos = y + height + 8; // headerY + headerHeight + gap
        
          doc.addImage(barcodeDataUrl, 'PNG', xPos, yPos, imgWidth, imgHeight);
        
        } catch (e) {
          console.error("Barcode :", e);
        }
        

        // ✅ Title text bhi barcode ke niche hi ayega
        doc.setFontSize(14).setFont('helvetica', 'bold');
        doc.text('Inpatient Provisional Bill (Summary)', pageCenter, y + height + 20, { align: 'center' });

        doc.setFontSize(10).setFont('helvetica', 'normal');
    }
} catch (error) {
    console.error("Could not add header image:", error);
}

    // doc.text(formData.billDateTime || '11-07-2025 22:32', pageCenter, 55, { align: 'center' });

    y = 140; // Title के नीचे से शुरू करें

    // ===================================
    // 2. Patient की जानकारी (दो-कॉलम लेआउट)
    // ===================================
    doc.setFontSize(10);
    const leftColX = 30;
    const rightColX = 330;
    const labelOffset = 110; // Label और value के बीच का gap

    const addInfoLine = (label1, value1, label2, value2) => {
        doc.setFont('helvetica', 'bold').text(label1, leftColX, y);
        doc.setFont('helvetica', 'normal').text(`: ${value1}`, leftColX + labelOffset, y);

        if (label2) {
            doc.setFont('helvetica', 'bold').text(label2, rightColX, y);
            doc.setFont('helvetica', 'normal').text(`: ${value2}`, rightColX + labelOffset, y);
        }
        y += 18; // अगली line के लिए Y position बढ़ाएं
    };

     

    addInfoLine('IPD No', ` 000${formData.ipd_bill_id}` || '', 'Bill No',` 000${formData.ipd_bill_id}` || '');
    addInfoLine('UHID No', formData.ipd_bill_uhid || formData.ot_uhid_no||'', 'Bill Date', formData.ipd_bill_date || '');
    addInfoLine('Patient Name', formData.ipd_bill_patient_name || '', 'Age/Sex', formData.ipd_bill_patient_age +`/ `+ formData.ipd_bill_patient_gender  || '');
    addInfoLine('Address', formData.ipd_bill_patient_address || '', 'Admission Date/Time', formData.ipd_bill_doa || '');
    addInfoLine('Bed', getBedNameById(formData.ipd_bill_bed) || '', 'Insurance Name', policyName || '');
    addInfoLine('Ward', getWardNameById(formData.ipd_bill_ward) || '', 'Insurance Number', policyNo || '0');
    addInfoLine('Ot Doctor', getDoctorNameById(formData.ipd_bill_concult_doctor) || '', '', ''); // Right side खाली है
    // addInfoLine('Procedure', formData.procedure || '', '', ''); // Right side खाली है

    y += 5;
    doc.setDrawColor(0).setLineWidth(0.5).line(20, y, pageWidth - 20, y); // Horizontal line

    

    const tableBody = formData.otitems.map((service, index) => [
        index + 1,
        service.ipd_bill_item_service,
        // Number को string में बदलकर .toFixed(2) लगाएं ताकि '2000' -> '2000.00' हो जाए
        Number(service.ipd_bill_item_final || 0).toFixed(2)
    ]);

     const total = parseFloat(formData.ipd_bill_total_amt || 0);

    // Summary data (इसे formData से बदलें)
    const summaryData = [
        ['', 'IPD Total Amount',total.toFixed(2) || ''],
        ['', 'IPD Paid Amount', Number(formData.ipd_bill_paid).toFixed(2) || '0.00'],
        ['', 'Lab Total Amount', finalPayment.toFixed(2) || '0.00'],
        //['', 'Lab Paid Amount', paidPayment.toFixed(2) || '0.00'],
        ['', 'PHAR Total Amount',  '0.00'],
        //['', 'PHAR Paid Amount',   '0.00'],
    ];

    autoTable(doc, {
        startY: y + 10,
        head: [['S.No', 'Particular of Services', 'Amount']],
        body: [...tableBody, ...summaryData],
        theme: 'grid', // 'grid' theme image से मिलता-जुलता है
        styles: {
            fontSize: 10,
            cellPadding: 4,
        },
        headStyles: {
            fontStyle: 'normal', // Image में Header bold नहीं है
            fillColor: false, // कोई background color नहीं
            textColor: 0,
            lineWidth: { top: 0, bottom: 0.7 },
            lineColor: [0, 0, 0],
        },
        columnStyles: {
            0: { halign: 'center', cellWidth: 50 },
            2: { halign: 'right', cellWidth: 120 },
        },
        // यह function table के बनने के बाद चलाया जाता है
        didParseCell: (data) => {
            // Summary rows के labels को right-align करें
            const summaryLabels = ['Total Amount', 'Discount', 'Advance', 'Due', 'Paid', 'Refund Amount'];
            if (data.section === 'body' && summaryLabels.some(label => data.cell.text[0].includes(label))) {
                data.cell.styles.halign = 'right';
                data.cell.styles.fontStyle = 'bold';
            }
        },
        margin: { left: 20, right: 20 },
    });

    // ===================================
    // 4. Footer
    // ===================================
    const pageHeight = doc.internal.pageSize.getHeight();
    doc.setFontSize(9).setFont('helvetica', 'normal');
    // doc.text(`Printed Time ${formData.printedTime || '11-07-2025 22:32'}      ${formData.footerId || '91373/OHAB'}`, 25, pageHeight - 25);
    doc.text('Authorized Signature', pageWidth - 25, pageHeight - 25, { align: 'right' });

    // --- PDF को नए टैब में खोलें ---
    doc.output('dataurlnewwindow');
  
};


 const printGatePass = (item) => {
    // Build a simple HTML gate-pass (customize markup & styles as needed)
    const win = window.open('', '_blank', 'width=800,height=900');
    if (!win) {
      Swal.fire("Popup blocked", "Please allow popups to print the gate pass.", "warning");
      return;
    }
  
    const html = `
      <html>
        <head>
          <title>Gate Pass - ${item.ipd_bill_patient_name}</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; color: #222; }
            .card { border: 1px solid #ddd; padding: 18px; border-radius: 6px; }
            h1 { font-size: 20px; margin-bottom: 6px; }
            .row { display:flex; gap:12px; margin-bottom:8px; }
            .label { font-weight:600; width:150px; }
            .value { flex:1; }
            .note { margin-top:18px; font-size:12px; color:#666;}
          </style>
        </head>
        <body>
  <div class="card">
    <h1>Gate Pass</h1>

    <div class="row"><div class="label">Patient Name:</div><div class="value">${escapeHtml(item.ipd_bill_patient_name || '')}</div></div>
    <div class="row"><div class="label">UHID</div><div class="value">${escapeHtml(item.ipd_bill_uhid || item.ipd_no || '')}</div></div>
    <div class="row"><div class="label">IPD No</div><div class="value">000${escapeHtml(item.ipd_no || '')}</div></div>
    <div class="row"><div class="label">Bed:</div><div class="value">${getBedNameById(formData.ipd_bill_bed) || ''}</div></div>
    <div class="row"><div class="label">Ward:</div><div class="value">${getWardNameById(formData.ipd_bill_ward) || ''}</div></div>
    <div class="row"><div class="label">Final Bill:</div><div class="value">₹${Number(item.ipd_bill_final_amt || item.lab_final_amount || 0).toFixed(2)}</div></div>
    <div class="row"><div class="label">Paid:</div><div class="value">₹${Number(item.ipd_bill_paid || item.ipd_paid || 0).toFixed(2)}</div></div>
    <div class="row"><div class="label">Due:</div><div class="value">₹${Number(item.ipd_bill_due || item.ipd_due || 0).toFixed(2)}</div></div>

    <!-- signature block (placed before printed timestamp) -->
    <div class="signature-block">
      <!-- if you have a signature image, replace the inner div with:
           <img class="sig-img" src="${formData.signature_url || ''}" alt="signature" /> -->
      <div class="sig-placeholder" aria-hidden="true"></div>
      <div class="sig-meta">
        <div class="sig-name">${escapeHtml(formData.authorized_name || 'Authorized Signatory')}</div>
        <div class="sig-designation">${escapeHtml(formData.authorized_designation || '')}</div>
      </div>
    </div>

    <div class="note printed-at">Printed at: ${new Date().toLocaleString()}</div>
  </div>
 <script>
            // Wait a tick then print and optionally close the window
            setTimeout(() => { window.print(); }, 300);
          </script>
  <style>
    /* keep this inside the template head or here if you prefer */
    .card { border: 1px solid #ddd; padding: 18px; border-radius: 6px; font-family: Arial, sans-serif; color:#222; }
    h1 { font-size: 20px; margin: 0 0 12px 0; text-align: center; }
    .row { display:flex; gap:12px; margin-bottom:8px; align-items:center; }
    .label { font-weight:600; width:150px; }
    .value { flex:1; }

    /* signature */
    .signature-block { display:flex; justify-content:flex-end; align-items:flex-end; margin-top:18px; margin-bottom:6px; gap:12px; }
    .sig-placeholder { width:220px; border-bottom:1px solid #000; height:2px; }
    .sig-meta { text-align:right; font-size:12px; color:#222; }
    .sig-name { font-weight:700; }
    .sig-designation { font-size:11px; color:#444; }

    .note { margin-top:8px; font-size:12px; color:#666; }
    .printed-at { margin-top:10px; }
  </style>
</body>

      </html>
    `;
  
    win.document.open();
    win.document.write(html);
    win.document.close();
  
    // helper to escape strings (defined below)
  };
  
  // small helper to escape HTML to avoid accidental XSS in printed page
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
  
 // Replace / insert into your React component file

// helper: read current user id (optional)
const currentUserId = localStorage.getItem("user_id") || 0;






async function markDischarged(item) {
  try {
    const fd = new FormData();
    if (item.ipd_id) fd.append('ipd_id', item.ipd_id);
    // ensure we also pass ipd_uhid if ipd_id not available
    if (!item.ipd_id && (item.ipd_uhid || item.ipd_bill_uhid)) {
      fd.append('ipd_uhid', item.ipd_uhid || item.ipd_bill_uhid);
    }
    // send current user id so backend records who performed discharge
    fd.append('user_id', currentUserId || 0);

    const resp = await axios.post(
      AppConst.BASE_URL + AppConst.markDischargedUrl,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    // return normalized object: { ok: boolean, data: ..., message: ... }
    if (resp && resp.data) {
      return {
        ok: !!resp.data.status,
        data: resp.data.ipd_dt || resp.data.ipd || null,
        message: resp.data.success || null,
        raw: resp.data
      };
    } else {
      return { ok: false, message: 'No response body', raw: resp };
    }
  } catch (err) {
    console.error("markDischarged axios error", err);
    return { ok: false, message: err.message || 'Request error', raw: err };
  }
}




const handleDischargeClick = async (item) => {
  console.log("Item : ", item);

  // Prevent re-entry
  if (busy) return;
  setBusy(true);

  try {
    // 1) Pending dues check
    if (duePayment > 0) {
      await Swal.fire({
        title: "Pending Payment",
        text: "Due Payment exists in Lab. Please clear the dues before discharge.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      });
      // don't mark discharged, just keep state as-is
      return;
    }

    // 2) If bed is assigned -> ask to unassign first
    const bedAssigned = !!item.ipd_bill_bed; // truthy check
    if (bedAssigned) {
      const unassignResult = await Swal.fire({
        title: "Bed is Assigned",
        text: `${item.ipd_bill_patient_name} has a bed assigned. Unassign the bed before discharge.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Unassign",
        cancelButtonText: "Close",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });

      if (!unassignResult.isConfirmed) {
        // user cancelled the unassign prompt — do nothing
        return;
      }

      // proceed to unassign bed
      try {
        const fd = new FormData();
        fd.append("bed_id", item.ipd_bill_bed);
        // pass a real user id if available; avoid magic 0
        fd.append("user_id", currentUserId ?? '');
        fd.append("status", 0); // your addBed endpoint might expect status=0 meaning free
        fd.append("bed_datetime", new Date().toISOString());

        const response = await axios.post(
          AppConst.BASE_URL + AppConst.addBedUrl,
          fd,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (!response || !response.data) {
          await Swal.fire("Error!", "No response from server when unassigning bed.", "error");
          return;
        }

        if (!response.data.status) {
          // endpoint responded but with failure
          await Swal.fire("Error!", response.data.success || "Failed to unassign bed", "error");
          return;
        }

        // bed unassigned successfully
        const choice = await Swal.fire({
          title: "Unassigned!",
          text: "Bed freed successfully.",
          icon: "success",
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: "Print Gate Pass",
          //denyButtonText: "Proceed to Discharge Summary",
          cancelButtonText: "Close",
          confirmButtonColor: "#3085d6",
          denyButtonColor: "#2ecc71",
        });

        // refresh UI (await so UI shows latest state). ignore minor errors but await it
        try { await initData(); } catch (e) { console.warn("initData refresh failed", e); }

        // helper to mark discharged
        const doMark = async () => {
          // markDischarged expected to return { ok: boolean, data?, message? }
          const r = await markDischarged(item);
          if (r && r.ok) {
            await Swal.fire("Done", "Patient discharged.", "success");
            return r.data;
          } else {
            await Swal.fire("Warning", "Could not mark discharged: " + (r?.message || "Unknown"), "warning");
            return null;
          }
        };

        if (choice.isConfirmed) {
          // Print gate pass then mark discharge
          try { await printGatePass(item); } catch (err) { console.warn("printGatePass failed", err); }
          await doMark();
        } else if (choice.isDenied) {
          // mark discharged then navigate to discharge summary
          const updatedIpd = await doMark();
          navigate('/discharge-summary', { state: { patientData: updatedIpd || item } });
        } else {
          // cancel => still perform discharge per your original logic
          await doMark();
        }

      } catch (err) {
        console.error("Unassign bed error:", err);
        await Swal.fire("Error!", "Something went wrong while unassigning bed.", "error");
        return;
      }
    } else {
      // No bed assigned -> directly confirm discharge (you may want a confirmation modal)
      const confirm = await Swal.fire({
        title: "Confirm Discharge",
        text: `Do you want to discharge ${item.ipd_bill_patient_name}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Discharge",
        cancelButtonText: "Cancel",
      });
      if (!confirm.isConfirmed) return;

      // directly mark discharged
      const r = await markDischarged(item);
      if (r && r.ok) {
        await Swal.fire("Done", "Patient discharged.", "success");
        try { await initData(); } catch (e) { console.warn("initData failed after discharge", e); }
      } else {
        await Swal.fire("Error", "Failed to discharge: " + (r?.message || ""), "error");
      }
    }
  } finally {
    // release busy flag
    setBusy(false);
  }
};


// from here end all this new ....

// Fetch transaction history any time a bill id or uhid becomes available/changes.
// Put this after your fetchTransactionHistory definition.
// ✅ Load transaction history when bill ID or UHID becomes available
// useEffect(() => {
//   const billId = formData.ipd_bill_id && String(formData.ipd_bill_id).trim();
//   const uhid =
//     (formData.ipd_bill_uhid && String(formData.ipd_bill_uhid).trim()) ||
//     (formData.ot_uhid_no && String(formData.ot_uhid_no).trim());

//   // Only fetch if we have a bill ID or UHID
//   if (billId || uhid) {
//     console.log("📋 Loading transaction history for:", { billId, uhid });
//     fetchTransactionHistory(uhid || billId);
//   }
// }, [formData.ipd_bill_id, formData.ipd_bill_uhid, formData.ot_uhid_no]);


// ✅ Load transaction history when bill ID or UHID becomes available
useEffect(() => {
  const billId = formData.ipd_bill_id && String(formData.ipd_bill_id).trim();
  const uhid =
    (formData.ipd_bill_uhid && String(formData.ipd_bill_uhid).trim()) ||
    (formData.ot_uhid_no && String(formData.ot_uhid_no).trim());

  if (billId || uhid) {
    console.log("📋 Loading transaction history for:", { billId, uhid });
    fetchTransactionHistory(uhid || billId);
  }
}, [formData.ipd_bill_id, formData.ipd_bill_uhid, formData.ot_uhid_no]);

// ✅ Fetch external dues when UHID changes
useEffect(() => {
  const uhid = formData.ipd_bill_uhid || formData.ot_uhid_no;
  
  if (uhid && String(uhid).trim() !== "") {
    console.log("🔍 Fetching dues for UHID:", uhid);
    
    (async () => {
      try {
        const fd = new FormData();
        fd.append('uhid', uhid);
        const resp = await axios.post(AppConst.BASE_URL + AppConst.checkUhidDueCall, fd);
        
        console.log("📦 Backend response:", resp?.data);
        
        if (resp?.data?.status) {
          const labData = resp.data.dues?.lab || {};
          const pharmacyData = resp.data.dues?.pharmacy || {};
          
          console.log("🧪 Lab data:", labData);
          console.log("💊 Pharmacy data:", pharmacyData);
          
          setFinalPayment(Number(labData.final || 0));
          setPaidPayment(Number(labData.paid || 0));
          setDuePayment(Number(labData.due || 0));
          
          setPharmacyFinal(Number(pharmacyData.final || 0));
          setPharmacyPaid(Number(pharmacyData.paid || 0));
          setPharmacyDue(Number(pharmacyData.due || 0));
          
          console.log("✅ Lab due set to:", Number(labData.due || 0));
          console.log("✅ Pharmacy due set to:", Number(pharmacyData.due || 0));
        }
      } catch (err) {
        console.error("❌ Error fetching dues:", err);
      }
    })();
  }
}, [formData.ipd_bill_uhid, formData.ot_uhid_no]);

// Debug: Monitor state changes
useEffect(() => {
  console.log("🔴 duePayment:", duePayment);
  console.log("🔴 pharmacyDue:", pharmacyDue);
}, [duePayment, pharmacyDue]);



const fetchTransactionHistory = async (idOrUhid) => {
  if (!idOrUhid) return;
  setIsLoading(true);

  try {
    const str = String(idOrUhid).trim();

    // 1) Try treating it as a bill id via GET (works even if id contains non-digits)
    try {
      const tryUrl = `${AppConst.BASE_URL + AppConst.GetPaymentIpdBill}/${encodeURIComponent(str)}`;
      const tryResp = await axios.get(tryUrl);
      if (tryResp && tryResp.data && tryResp.data.status) {
        const history = tryResp.data.history || tryResp.data.transaction_history || tryResp.data.data || [];
        setTransactionHistory(Array.isArray(history) ? history : []);
        setIsLoading(false);
        return;
      }
    } catch (errGet) {
      // GET failed or returned non-status — we'll fallback to UHID POST below
      //console.debug("fetchTransactionHistory: GET by bill id failed, trying UHID POST", errGet);
    }

    // 2) Fallback: treat it as UHID and POST
    try {
      const fd = new FormData();
      fd.append('uhid', str);
      const postUrl = AppConst.BASE_URL + (AppConst.GetPaymentIpdBillByUhidUrl || AppConst.GetPaymentIpdBill);
      const resp = await axios.post(postUrl, fd, { headers: { 'Content-Type': 'multipart/form-data' } });

      if (resp && resp.data && resp.data.status) {
        const history = resp.data.history || resp.data.transaction_history || resp.data.data || [];
        setTransactionHistory(Array.isArray(history) ? history : []);
      } else {
        setTransactionHistory([]);
      }
    } catch (errPost) {
      console.error("fetchTransactionHistory UHID POST failed", errPost);
      setTransactionHistory([]);
    }

  } catch (err) {
    console.error("fetchTransactionHistory unexpected error", err);
    setTransactionHistory([]);
  } finally {
    setIsLoading(false);
  }
};




// Recalculate computedPaid and computedDue whenever transactions, advance or final amount change
useEffect(() => {
  const adv = Number(formData.ipd_bill_adv_amount || 0);
  const finalAmt = Number(formData.ipd_bill_final_amt || 0);

  // sum transaction history payments (if each record uses 'payment_amount' field)
  const transSum = (transactionHistory || []).reduce((s, t) => s + (Number(t.payment_amount || t.payment_amount || 0)), 0);

  const newPaid = adv + transSum;
  const newDue = Math.max(0, finalAmt - newPaid);

  // update local derived states
  setComputedPaid(newPaid);
  setComputedDue(newDue);

  // keep ipd_bill_paid and ipd_bill_due fields in formData in sync (readonly behavior)
  setFormData(prev => {
    // avoid unnecessary state churn by early-return if nothing changed
    const prevPaid = Number(prev.ipd_bill_paid || 0);
    const prevDue = Number(prev.ipd_bill_due || 0);

    if (prevPaid === newPaid && prevDue === newDue) {
      return prev;
    }
    return {
      ...prev,
      ipd_bill_paid: newPaid,
      ipd_bill_due: newDue
    };
  });

  // also reflect lab/pharmacy UI states for quick view
  setDuePayment(newDue); // re-use existing state for Lab due display if appropriate
}, [transactionHistory, formData.ipd_bill_adv_amount, formData.ipd_bill_final_amt]);



       useEffect(() => {
        fetchTransactionHistory(formData.ipd_bill_uhid || formData.ot_uhid_no);
    }, [formData.ipd_bill_uhid ,formData.ot_uhid_no]);

// IpdBilling.js - add this helper (adjust AppConst key as needed)
const fetchExistingIpdBill = async ({ uhid, ipdId }) => {
  try {
    const fd = new FormData();
    if (uhid) fd.append('ipd_bill_uhid', uhid);
    if (ipdId) fd.append('ipd_id', ipdId);

    // Replace the AppConst constant below with the actual endpoint from your backend
    const url = AppConst.BASE_URL + (AppConst.getIpdBillByUhidUrl || AppConst.getIpdBillUrl ||AppConst.addIpdBillUrl ||AppConst.searchUhidUrlCall ||AppConst.checkUhidDueCall);


    const resp = await axios.post(url, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    return resp?.data || null;
  } catch (err) {
    //console.error('fetchExistingIpdBill error', err);
    return null;
  }
};

// Returns an object { lab: { final, paid, due }, pharmacy: { final, paid, due } }
// If API returns differently, adapt the key mapping.
const safeNum = (v) => {
  const n = Number(v);
  return isNaN(n) ? 0 : n;
};

const checkExternalDues = async (uhid) => {
  if (!uhid) return { lab: { final: 0, paid: 0, due: 0 }, pharmacy: { final: 0, paid: 0, due: 0 } };
  try {
    const fd = new FormData();
    fd.append('uhid', uhid);
    const resp = await axios.post(AppConst.BASE_URL + AppConst.checkUhidDueCall, fd);
    if (resp?.data?.status) {
      const labRaw = resp.data.dues?.lab || resp.data.dues?.Lab || {};
      const pharmacyRaw = resp.data.dues?.pharmacy || resp.data.dues?.phar || resp.data.dues?.pharmacy_due || {};

      const lab = {
        final: safeNum(labRaw.final),
        paid: safeNum(labRaw.paid),
        due: safeNum(labRaw.due),
      };
      const pharmacy = {
        final: safeNum(pharmacyRaw.final),
        paid: safeNum(pharmacyRaw.paid),
        due: safeNum(pharmacyRaw.due),
      };

      // update local UI states explicitly from these values only
      setFinalPayment(lab.final);
      setPaidPayment(lab.paid);
      setDuePayment(lab.due);
      setPharmacyFinal(pharmacy.final);
      setPharmacyPaid(pharmacy.paid);
      setPharmacyDue(pharmacy.due);

      return { lab, pharmacy };
    }
  } catch (err) {
    //console.error('checkExternalDues error', err);
  }
  return { lab: { final: 0, paid: 0, due: 0 }, pharmacy: { final: 0, paid: 0, due: 0 } };
};




// ✅ Delete transaction (admin only)
const handleDeleteTransaction = async (paymentId) => {
  // ensure permission using the same local check
  if (!isAdminLocal) {
    toast.error('Only administrators can delete transactions');
    return;
  }

  const { isConfirmed } = await Swal.fire({
    title: 'Delete Transaction?',
    text: 'Are you sure you want to delete this payment transaction? This action cannot be undone.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
  });

  if (!isConfirmed) return;

  try {
    const fd = new FormData();
    fd.append('payment_id', paymentId);
    // pass server-side user id if available (fallback to 0)
    const stored = getStoredUserLocal();
    fd.append('user_id', (stored && (stored.user_id || stored.userId || stored.id)) || 0);

    const url = AppConst.BASE_URL + AppConst.deletePaymentTransactionUrl;
    const resp = await axios.post(url, fd, { headers: { 'Content-Type': 'multipart/form-data' } });

    if (resp?.data?.status) {
      toast.success('Transaction deleted successfully');

      const uhid = formData.ipd_bill_uhid || formData.ot_uhid_no || '';
      const billId = formData.ipd_bill_id || '';

      if (uhid || billId) {
        await fetchTransactionHistory(uhid || billId);
      }

      if (resp.data.updated_bill) {
        const upd = resp.data.updated_bill;
        setFormData(prev => ({
          ...prev,
          ipd_bill_paid: Number(upd.ipd_bill_paid || 0),
          ipd_bill_due: Number(upd.ipd_bill_due || 0)
        }));
      }
    } else {
      toast.error(resp?.data?.message || 'Failed to delete transaction');
    }
  } catch (err) {
    console.error('Delete transaction error:', err);
    toast.error('Failed to delete transaction');
  }
};

const doPayment = async () => {
  const payVal = Number(payAmount || 0);
  const uhid = formData.ipd_bill_uhid || formData.ot_uhid_no || '';
  const billId = formData.ipd_bill_id || '';
  const ipdNo = formData.ipd_no || '';

  if (!uhid && !billId) {
    toast.error('Bill/UHID missing. Save the bill first.');
    return;
  }
  if (payVal <= 0) {
    toast.error('Enter a valid amount to pay.');
    return;
  }
  if (payVal > computedDue) {
    toast.error(`Pay amount cannot exceed due (₹${computedDue.toFixed(2)})`);
    return;
  }

  try {
    const fd = new FormData();
    fd.append('ipd_bill_uhid', uhid);
    fd.append('ipd_bill_id', billId);
    fd.append('ipd_no', ipdNo);
    fd.append('payment_amount', payVal);
    fd.append('payment_method', formData.ipd_bill_pay_mode || 'Cash');
    fd.append('user', ldata?.user_id || formData.ipd_bill_user || 0);

    const url = AppConst.BASE_URL + (AppConst.addPaymentTransactionUrl || AppConst.addPaymentUrl || AppConst.PaymentIpdBillUrl);
    const resp = await axios.post(url, fd, { headers: { 'Content-Type': 'multipart/form-data' } });

    if (resp?.data?.status) {
      toast.success(resp.data.success || 'Payment added');

      // ✅ Update transaction history from response
      if (Array.isArray(resp.data.transaction_history) && resp.data.transaction_history.length > 0) {
        console.log("✅ Setting transaction history from payment response:", resp.data.transaction_history.length);
        setTransactionHistory(resp.data.transaction_history);
      } else {
        // Fallback: fetch manually
        console.log("⚠️ No transaction_history in response, fetching manually");
        await fetchTransactionHistory(uhid || billId);
      }

      // Update bill paid/due if backend sent updated values
      if (resp.data.updated_bill) {
        const upd = resp.data.updated_bill;
        setFormData(prev => ({
          ...prev,
          ipd_bill_paid: Number(upd.ipd_bill_paid || 0),
          ipd_bill_due: Number(upd.ipd_bill_due || 0)
        }));
      }

      setPayAmount(''); // Clear pay input
    } else {
      toast.error(resp?.data?.success || 'Payment failed');
    }
  } catch (err) {
    console.error('doPayment error', err);
    toast.error('Payment request failed.');
  }
};



    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">

                        <h2 style={{ color: "#405189" }}>IPD Billing</h2>
                        <br />
                        <div class="live-preview">
                            <form onSubmit={handleSubmit}>
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                             <div class="col-lg-12">
                                                <h5 style={{ color: "#405189" }}>Patient Details</h5>
                                                <br />
                                            </div>
                                            {/* <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">IPD Number</label>
                                                    <input name="ipd_parent_number" onChange={handleChange} value={formData.ipd_parent_number} class="form-control" placeholder="Enter IPD Number" type="text" required />
                                                </div>
                                            </div> */}
                                                                         <div className="col-md-4">
    {/* Wrapper div ko 'position-relative' banana zaroori hai */}
    <div className="mb-3 position-relative">
        <label htmlFor="ot-uhid-field" className="form-label">UHID Number</label>
        <input 
            id="ot-uhid-field"
            name="ot_uhid_no" 
            onChange={handleChange} 
            value={formData.ot_uhid_no} 
            className="form-control" 
            placeholder="Enter UHID Number" 
            type="text"
            // Naye functions ko yahan attach karein
            onKeyUp={searchOtUserNow}
            autoComplete="off"
            required
        />

       {otUhidSuggestions.length > 0 && (
  <ul className="list-group position-absolute w-100" style={{ zIndex: 10 }}>
    {otUhidSuggestions.map((user, idx) => (
      <li
        key={idx}
        className="list-group-item list-group-item-action"
        onClick={() => handleSelectOtUser(user)}
        style={{ cursor: "pointer" }}
      >
        {/* Agar lab_reg_uhid empty ho to ipd_bill_uhid use karo */}
        {(user.lab_reg_uhid || user.ipd_bill_uhid) ?? "NA"} - {(user.lab_reg_name || user.ipd_bill_patient_name) ?? "NA"}
        <span className="badge bg-info ms-2">{user.lab_reg_type || "IPD"}</span>
      </li>
    ))}
  </ul>
)}

    </div>
</div><input type="hidden" name="ipd_no" value={formData.ipd_no || ''} />
<div className="col-md-4">
  <div>
    <label htmlFor="doa-field" className="form-label">DOA</label>
    <input
  id="doa-field"
  name="ipd_bill_doa"
  onChange={handleChange}
  value={formatDateTimeLocal(formData.ipd_bill_doa) || ""}
  className="form-control"
  placeholder="Enter Reg. Date"
  type="datetime-local"
  required
  readOnly
/>

  </div>
</div>

                                             <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Patient Name</label>
                                                    <input name="ipd_bill_patient_name" onChange={handleChange} value={formData.ipd_bill_patient_name} class="form-control" placeholder="Enter Patient Name" type="text" required readOnly/>
                                                </div>
                                            </div>
                                            <div class="col-md-12"><br /></div>
                                           
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Patient Phone</label>
                                                    <input name="ipd_bill_patient_phone" onChange={handleChange} value={formData.ipd_bill_patient_phone}
                                                        class="form-control" placeholder="Enter Patient Phone" type="text" required readOnly/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Patient Address</label>
                                                    <input name="ipd_bill_patient_address" onChange={handleChange} value={formData.ipd_bill_patient_address}
                                                        class="form-control" placeholder="Enter Patient Address" type="text" required readOnly/>
                                                </div>
                                            </div>
                                             <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Gender</label>
                                                   <select
  className="form-control"
  name="ipd_bill_patient_gender"
  onChange={handleChange}
  value={formData.ipd_bill_patient_gender || ""}
  required
  readOnly // remove readOnly if you want the user to change gender
>
  <option value="">Select Gender</option>
  <option value="Male">Male</option>
  <option value="Female">Female</option>
  <option value="Other">Other</option>
</select>

                                                </div>
                                            </div>
                                            <div class="col-md-12"><br /></div>
                                           
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Age</label>
                                                    <input name="ipd_bill_patient_age" onChange={handleChange} value={formData.ipd_bill_patient_age} class="form-control" placeholder="Enter Age" type="text" required readOnly/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Ward</label>
                                                    <input name="ipd_bill_ward" onChange={handleChange} value={getWardNameById(formData.ipd_bill_ward)} class="form-control" placeholder="Enter Ward" type="text" required  readOnly/>
                                                </div>
                                            </div>
                                              <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Bed</label>
                                                    <input name="ipd_bill_bed" onChange={handleChange} value={getBedNameById(formData.ipd_bill_bed)} class="form-control" placeholder="Enter Bed" type="text" required readOnly />
                                                </div>
                                            </div>
                                            <div class="col-md-12"><br /></div>
                                          
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Billing Date</label>
                                                    <input 
  name="ipd_bill_date" 
  onChange={handleChange} 
  value={
    new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0,16)
  } 
  className="form-control" 
  type="datetime-local" 
  required 
  readOnly 
/>



                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Referred Doctor</label>
                                                    <input name="ipd_bill_refered_doctor" onChange={handleChange} value={getDoctorNameById(formData.ipd_bill_refered_doctor)} class="form-control" placeholder="Enter Referred Doctor" type="text" required readOnly />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
    <div >
        <label for="customername-field" class="form-label">OT Doctor</label>
        <input 
            name="ipd_bill_concult_doctor" 
            onChange={handleChange} 
            value={getDoctorNameById(formData.ipd_bill_concult_doctor)} 
            class="form-control" 
            placeholder="OT Doctor" 
            type="text" 
            readOnly 
        />
    </div>
</div>

{/* ADD THESE NEW DOCTOR FIELDS */}
<div class="col-md-4">
    <div>
        <label for="customername-field" class="form-label">Asst. OT Doctor</label>
        <input 
            name="ot_asst_doctor_display" 
            value={getDoctorNameById(formData.ot_asst_doctor) || otAsstDocSearch || "N/A"} 
            class="form-control" 
            placeholder="Asst. OT Doctor" 
            type="text" 
            readOnly 
        />
    </div>
</div>

<div class="col-md-4">
    <div>
        <label for="customername-field" class="form-label">Anesthesia Doctor</label>
        <input 
            name="ot_anesthesia_doctor_display" 
            value={getDoctorNameById(formData.ot_anesthesia_doctor) || otAnesthesiaDocSearch || "N/A"} 
            class="form-control" 
            placeholder="Anesthesia Doctor" 
            type="text" 
            readOnly 
        />
    </div>
</div>




<div class="col-md-4">
    <div>
        <label for="customername-field" class="form-label">Pediatric Doctor</label>
        <input 
            name="ot_pediatric_doctor_display" 
            value={getDoctorNameById(formData.ot_pediatric_doctor) || otPediatricDocSearch || "N/A"} 
            class="form-control" 
            placeholder="Pediatric Doctor" 
            type="text" 
            readOnly 
        />
    </div>
</div>




{/* Broker Info Display */}
<div class="col-md-4">
    <div>
        <label for="customername-field" class="form-label">Broker Name</label>
        <input 
            name="ipd_broker_name_display" 
            value={formData.ipd_broker_name || formData.broker_name || "N/A"} 
            class="form-control" 
            placeholder="Broker Name" 
            type="text" 
            readOnly 
        />
    </div>
</div>


<div class="col-md-4">
    <div>
        <label for="customername-field" class="form-label">Insurance Name</label>
        <input 
            name="ipd_policy_name" 
            value={formData.ipd_policy_name || policyName || "N/A"} 
            onChange={handleChange}
            class="form-control" 
            placeholder="Insurance Name" 
            type="text" 
            readOnly 
        />
    </div>
</div>
{/* 
<div class="col-md-4">
    <div>
        <label for="customername-field" class="form-label">Insurance Claim ID</label>
        <input 
            name="ipd_policy_no" 
            value={formData.ipd_policy_no || policyNo || "N/A"} 
            onChange={handleChange}
            class="form-control" 
            placeholder="Insurance Number" 
            type="text" 
            readOnly 
        />
    </div>
</div> */}


<div class="col-md-12"><br /></div>
                                            <input type="hidden" name="ipd_bill_ot" value={formData.ipd_bill_ot || otDate || ''} />
                                           
                                            
                                            <div class="col-md-12"><br /></div>
                                            

                                        </div>
                                        </div></div>
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <br />
                                                <div class="row">
                                               <div className="col-2"></div>
                                               <div className="col-md-8">
  <div className="mb-3 position-relative">
    <label className="form-label">Select Service</label>

    <input
      ref={serviceSearchRef}
      type="text"
      className="form-control service-search-input"
      placeholder="Search services..."
      name="search_key"
      value={formData.search_key}
      onChange={(e) => {
        handleChange(e);
        setShowServices(e.target.value.length > 0);
      }}
      onFocus={() => {
        if (formData.services && formData.services.length > 0) {
          setShowServices(true);
        }
      }}
      onKeyUp={initData}
      autoComplete="off"
      style={{ height: 48, padding: "10px 12px", borderRadius: 8 }}
    />

    {/* Suggestions list */}
    {showServices && formData.services && formData.services.length > 0 && (
      <ul
        ref={serviceListRef}
        className="list-group service-suggestions shadow-sm"
        style={{
          position: "absolute",
          zIndex: 1050,
          top: "100%",
          left: 0,
          right: 0,
          maxHeight: 260,
          overflowY: "auto",
          borderRadius: 8,
          marginTop: 8,
          padding: 0,
        }}
      >
        {formData.services.map((srv, idx) => (
          <li
            key={idx}
            className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer", padding: "10px 12px" }}
            onClick={() => {
              // call your helper to add service into items
              addServiceToItems(srv);
            }}
          >
            <div>
              <div style={{ fontWeight: 600 }}>{srv.cat_name}</div>
              {srv.cat_desc && <small className="text-muted d-block">{srv.cat_desc}</small>}
            </div>
            {srv.cat_price ? (
              <span className="badge bg-success">₹{Number(srv.cat_price).toFixed(2)}</span>
            ) : null}
          </li>
        ))}
      </ul>
    )}
  </div>
</div>

<div className="col-2"></div>


                                                </div>
                                             <div class="d-flex gap-1 flex-wrap">
                    <button id="addbt453" style={{display:"none"}} type="button" class="btn btn-success add-btn" data-bs-toggle="modal" data-bs-target="#showModal" fdprocessedid="jys8hw">
                    </button>
                      <button type="button" class="btn btn-success add-btn"
                       onClick={(e) => {
                        e.preventDefault();
                        document.getElementById("addbt453").click();
                      }}
                      >
                        <i class="ri-add-line align-bottom me-1"></i> Add Service </button>
                      <button class="btn btn-soft-danger" id="remove-actions">
                        <i class="ri-delete-bin-2-line"></i>
                      </button>
                    </div>
                                                <br />
                                            </div>

                                            {/* ---------- Modern Services Table (replace old table) ---------- */}
<div className="modern-services-table card p-3">
  <div className="d-flex align-items-center justify-content-between mb-3">
    <h6 className="mb-0">Services</h6>
    <div className="d-flex gap-2">
      
     
    </div>
  </div>

  <div className="table-responsive modern-table-responsive">
    <table className="table modern-table mb-0">
      <thead>
        <tr>
          <th className="col-sn">S. No.</th>
          <th className="col-service">Service</th>
          <th className="col-qty">QTY</th>
          <th className="col-charge">Unit Price</th>
          <th className="col-dis">Discount</th>
          <th className="col-final">Final</th>
          <th className="col-act">Action</th>
        </tr>
      </thead>

      <tbody>
        {formData.otitems.map((item, index) => (
          <tr key={index} className={item.isBedItem ? "row-bed" : ""}>
            <td className="align-middle text-muted">{index + 1}</td>

            <td>
              <input
                name={`ipd_bill_item_service${index}`}
                value={item.ipd_bill_item_service}
                onChange={(e) => handleChange1(e, index)}
                className="form-control modern-input service-input"
                placeholder="Service name"
                type="text"
                readOnly={true} 
              />
              {item.isBedItem && <small className="text-muted">Bed charge (auto)</small>}
            </td>

            <td>
              <input
                name={`ipd_bill_item_qty${index}`}
                value={item.ipd_bill_item_qty}
                onChange={(e) => handleChange1(e, index)}
                className="form-control modern-input qty-input"
                placeholder="QTY"
                type="number"
                min={1}
                readOnly={item.isBedItem}
              />
            </td>

            <td>
              <input
                name={`ipd_bill_item_charge${index}`}
                value={item.ipd_bill_item_charge}
                onChange={(e) => handleChange1(e, index)}
                className="form-control modern-input price-input"
                placeholder="Unit price"
                type="number"
                min={0}
                step="0.01"
                readOnly={item.isBedItem}
              />
            </td>

            <td>
              <input
                name={`ipd_bill_item_dis${index}`}
                value={item.ipd_bill_item_dis}
                onChange={(e) => handleChange1(e, index)}
                className="form-control modern-input dis-input"
                placeholder="Discount"
                type="number"
                min={0}
                step="0.01"
              />
            </td>

            <td>
              <input
                name={`ipd_bill_item_final${index}`}
                value={item.ipd_bill_item_final}
                className="form-control modern-input final-input"
                placeholder="Final"
                type="number"
                readOnly
              />
            </td>

            <td className="text-center">
              {!item.isBedItem ? (
                <button
                  className="btn btn-sm delete-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    const updated = formData.otitems.filter((_, i) => i !== index);
                    setFormData((prev) => ({ ...prev, otitems: updated }));
                  }}
                  title="Remove service"
                >
                  {/* SVG trash icon */}
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <path d="M9 3v1H4v2h16V4h-5V3H9z" />
          <path d="M6 7l1 14a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-14H6zm5 3v8h-2v-8h2zm4 0v8h-2v-8h2z" />
        </svg>
                </button>
              ) : (
                <span className="text-muted small">—</span>
              )}
            </td>
          </tr>
        ))}

        {/* totals row */}
        <tr className="totals-row">
          <td colSpan="3" />
          <td className="text-end pe-3"><strong>Total</strong></td>
          <td colSpan="1" className="text-end">
            <strong>₹{Number(formData.ipd_bill_total_amt || 0).toFixed(2)}</strong>
          </td>
          <td colSpan="2" className="text-end">
            <small className="text-muted d-block">Final Amount</small>
            <strong>₹{Number(formData.ipd_bill_final_amt || 0).toFixed(2)}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>




                                        </div></div></div>






                                        {/* ---------- TABS: Lab / Pharmacy / Store ---------- */}

                                        <div class="card">
                                        <div class="card-body">
                                        <div class="col-lg-12">
                                                <h6 style={{ color: "#405189" }}>Transaction History</h6>
                                                <br />
                                            </div>
         <div className="row">
        

 
   
    

    <table className="table table-bordered">
  <thead>
    <tr>
      <th>S.No.</th>
      <th>Payment Date</th>
      <th>Payment Time</th>
      <th>Payment</th>
      <th>Payment Type</th>
      <th>Payment Method</th>
      <th>Received By</th>
      {isAdminLocal && <th>Action</th>}
    </tr>
  </thead>
  <tbody>
    {isLoading ? (
      <tr>
        <td colSpan={isAdminLocal ? 8 : 7}>Loading...</td>
      </tr>
    ) : transactionHistory.length > 0 ? (
      transactionHistory.map((trx, index) => (
        <tr key={trx.payment_id || index}>
          <td>{index + 1}</td>
          <td>{new Date(trx.payment_date).toLocaleDateString('en-GB')}</td>
          <td>{trx.payment_time}</td>
          <td>{parseFloat(trx.payment_amount || 0).toFixed(2)}</td>
          <td>{trx.payment_type}</td>
          <td>{trx.payment_method}</td>
          <td>{getUserNameById(trx.received_by, trx)}</td>

          {isAdminLocal && (
            <td className="text-center">
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => handleDeleteTransaction(trx.payment_id)}
                title="Delete transaction"
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
              >
                {/* react-icons SVG (reliable) */}
                <RiDeleteBinLine size={16} aria-hidden="true" />
              </button>
            </td>
          )}
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={isAdminLocal ? 8 : 7}>No Transactions Found.</td>
      </tr>
    )}
  </tbody>
</table>

  


         </div>

         </div>
         </div>





{/* ✅ NEW: Lab & Pharmacy Dues Section */}
{(Number(duePayment) > 0 || Number(pharmacyDue) > 0) && (
    <div className="card mt-3">
        <div className="card-body">
            <div className="col-lg-12">
                <h6 style={{ color: "#dc3545" }}>⚠️ External Pending Dues</h6>
                <br />
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="alert alert-warning" role="alert">
                        <strong>Note:</strong> This patient has pending dues in other departments. Please clear these before discharge.
                    </div>
                </div>

                {/* Lab Dues */}
                {Number(duePayment) > 0 && (
                    <div className="col-md-6">
                        <div className="card border-warning">
                            <div className="card-header bg-warning bg-opacity-10">
                                <h6 className="mb-0">🧪 Lab Billing</h6>
                            </div>
                            <div className="card-body">
                                <table className="table table-sm table-borderless mb-0">
                                    <tbody>
                                        <tr>
                                            <td><strong>Total Amount:</strong></td>
                                            <td className="text-end">₹{Number(finalPayment).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Paid:</strong></td>
                                            <td className="text-end">₹{Number(paidPayment).toFixed(2)}</td>
                                        </tr>
                                        <tr className="border-top">
                                            <td><strong className="text-danger">Due Amount:</strong></td>
                                            <td className="text-end"><strong className="text-danger">₹{Number(duePayment).toFixed(2)}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}

                {/* Pharmacy Dues */}
                {Number(pharmacyDue) > 0 && (
                    <div className="col-md-6">
                        <div className="card border-warning">
                            <div className="card-header bg-warning bg-opacity-10">
                                <h6 className="mb-0">💊 Pharmacy Billing</h6>
                            </div>
                            <div className="card-body">
                                <table className="table table-sm table-borderless mb-0">
                                    <tbody>
                                        <tr>
                                            <td><strong>Total Amount:</strong></td>
                                            <td className="text-end">₹{Number(pharmacyFinal).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Paid:</strong></td>
                                            <td className="text-end">₹{Number(pharmacyPaid).toFixed(2)}</td>
                                        </tr>
                                        <tr className="border-top">
                                            <td><strong className="text-danger">Due Amount:</strong></td>
                                            <td className="text-end"><strong className="text-danger">₹{Number(pharmacyDue).toFixed(2)}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    </div>
)}


                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <h5 style={{ color: "#405189" }}>Payment Details</h5>
                                                <br />
                                            </div>
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Total Amount</label>
                                                    <input type="text" class="form-control" placeholder="Enter Total Amount" name="ipd_bill_total_amt" onChange={handleChange} value={formData.ipd_bill_total_amt} required  readOnly style={{background: "#EEE"}}/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Discount(%)</label>
                                                    <input type="text" class="form-control" placeholder="Enter Discount" name="ipd_bill_discount" onChange={handleChange} value={formData.ipd_bill_discount} />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Fixed Discount</label>
                                                    <input type="text" class="form-control" placeholder="Enter Fixed Deposit" name="ipd_bill_fixed_deposit" onChange={handleChange} value={formData.ipd_bill_fixed_deposit} />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Final Amount</label>
                                                    <input type="text" class="form-control" placeholder="Enter Final Amount" name="ipd_bill_final_amt" onChange={handleChange} value={formData.ipd_bill_final_amt} required readOnly style={{background: "#EEE"}}/>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Advance Amount</label>
                                                    <input type="text" class="form-control" placeholder="Enter Paid" name="ipd_bill_adv_amount" onChange={handleChange} value={formData.ipd_bill_adv_amount} required readOnly style={{background: "#EEE"}} />
                                                </div>
                                            </div>
                                           {/* Paid (readonly) */}
<div className="col-md-4">
  <div className="mb-3">
    <label className="form-label">Paid (Advance + Payments)</label>
    <input
      type="text"
      className="form-control"
      name="ipd_bill_paid"
      value={Number(computedPaid || 0).toFixed(2)}
      readOnly
      style={{ background: "#EEE" }}
    />
    <small className="text-muted">Shows Advance + payments recorded in IPD transaction history.</small>
  </div>
</div>

{/* Pay input + button */}
<div className="col-md-4">
  <div className="mb-3">
    <label className="form-label">Pay</label>
    <div className="input-group">
      <input
        type="number"
        className="form-control"
        placeholder="Enter amount to pay"
        value={payAmount}
        onChange={(e) => setPayAmount(e.target.value)}
        min="0"
        step="0.01"
        disabled={Number(computedDue) <= 0}
      />
      <button
        type="button"
        className="btn btn-primary"
        onClick={async () => {
          // optionally ensure bill is saved first
          if (!formData.ipd_bill_id) {
            toast.error("Save the bill first (press Save) before recording payment.");
            return;
          }
          await doPayment();
        }}
        disabled={Number(computedDue) <= 0 || Number(payAmount || 0) <= 0}
      >
        Pay
      </button>
    </div>
    <small className="text-muted">
      Max payable: ₹{Number(computedDue || 0).toFixed(2)}.
    </small>
  </div>
</div>

{/* Due (readonly) */}
<div className="col-md-4">
  <div className="mb-3">
    <label className="form-label">Due Amount</label>
    <input
      type="text"
      className="form-control"
      name="ipd_bill_due"
      value={Number(computedDue || 0).toFixed(2)}
      readOnly
      style={{ background: "#EEE" }}
    />
  </div>
</div>


                                            {/* <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Pay Mode</label>
                                                    <input type="text" class="form-control" placeholder="Enter Pay Mode" name="ipd_bill_pay_mode" onChange={handleChange} value={formData.ipd_bill_pay_mode} required />
                                                </div>
                                            </div> */}
                                             <div className="col-md-4">
                          <div className="mb-3">
                            <label htmlFor="paymentMode" className="form-label">
                              Payment Mode
                            </label>
                            <select
                              className="form-control"
                              name="ipd_bill_pay_mode"
                              onChange={handleChange}
                              value={formData.ipd_bill_pay_mode}
                              required
                            >
                              <option value="">Select Payment Mode</option>
                              <option value="Cash">Cash</option>
                              <option value="Online">Online</option>
                              <option value="Card">Card</option>
                            </select>
                          </div>
                        </div>
                                            <div class="col-md-12">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">Remarks</label>
                                                    <textarea class="form-control" placeholder="Enter Remarks"
                                                        name="ipd_bill_remarks" onChange={handleChange} value={formData.ipd_bill_remarks} ></textarea>
                                                </div>
                                            </div>
                                           
                                            <div class="col-lg-12">
                                                <div class="text-end">
                                         
                                               

                                                    &nbsp;&nbsp;&nbsp;
                                                    <button type="submit" class="btn btn-dark">Save</button>
                                                    &nbsp;&nbsp;&nbsp;


                                                    <button
  type="button"
  className="btn btn-warning"
  disabled={!isFinalized}
  onClick={() => {
    setModalPatient(formData);      // pass current billing form object
    setShowDischargeModal(true);
  }}
>
  Discharge Sheet
</button>


  &nbsp;&nbsp;&nbsp;
                                                  <button 
  type="button" 
  className="btn btn-dark" 
  datatype={isFinalized}
  data={formData.ipd_bill_due}
disabled={!(isFinalized && formData.ipd_bill_due <= 0)}

onClick={handlePrintIPDBill}
>
  IPD Final Bill Print
</button>
&nbsp;&nbsp;&nbsp;

<button 
  type="button" 
  className="btn btn-dark" 
disabled={!(isFinalized && formData.ipd_bill_due <= 0)}

  onClick={() => generateProvisionalBill(formData)}
>
  Provisional Bill
</button>
&nbsp;&nbsp;&nbsp;

<button
  type="button"
  className="btn btn-primary"
  disabled={!(isFinalized && Number(formData.ipd_bill_due) <= 0 && Number(duePayment) <= 0)}
  onClick={() => handleDischargeClick(formData)}
>
  Discharge Patient
</button>

&nbsp;&nbsp;&nbsp;
<button 
            type="button" 
            className="btn btn-danger"
            onClick={() => navigate('/ipd_pataint_list')}
        >
            Cancel
        </button>


                                                </div>
                                            </div>
                                        </div>
                                    </div></div>
                            </form>
                        </div>

                    </div>

                </div>
            </div>
                  <AddService onAddDepart={handleAddDepart} />
                 
{showDischargeModal && modalPatient && (
  <DischargeModal
    patientData={modalPatient}
    onClose={() => {
      console.log("DischargeModal onClose called");
      setShowDischargeModal(false);
      setModalPatient(null);
    }}
    onSaved={(saved) => {
      console.log("DischargeModal onSaved", saved);
      setShowDischargeModal(false);
      setModalPatient(null);
      // refresh local data if needed
      initData();
      toast.success("Discharge saved");
    }}
  />
)}
<AddService onAddDepart={handleAddDepart} />

        </div>
        
    );
}

export default IpdBilling;
